/* Guia de cuidado — mecanicas interactivas (diagnostico, anatomia, manchas,
   rescate, fichas y tabla). Generado por _referencia/build-mecanicas-web.py
   desde guia-cuidado-calzado/prototipo.html. NO editar a mano. */
(function () {
  "use strict";

  /* ---------------- Datos (copia literal del prototipo) ---------------- */

  var MATERIALES = [
    {
      id: "mesh", nombre: "Telas", cod: "TEX-01", sw: "sw-mesh",
      resumen: "Mesh, knit y canvas. Mesh y knit son plástico tejido y se tratan igual. El canvas es algodón: absorbe como una toalla.",
      reconocer: "Trama visible al trasluz y tacto seco = <b>mesh</b>. Tejido elástico que se estira = <b>knit</b>. Tela gruesa de algodón, tipo Converse = <b>canvas</b>. Los dos primeros se limpian igual; el canvas necesita más enjuague.",
      debilidades: ["La cerda dura no limpia la trama: la corta, y la fibra cortada no vuelve", "En las running la mugre se mete <b>entre las capas</b> y no sale frotando por arriba", "El canvas queda amarillo si no enjuagas todo el shampoo"],
      spec: { "Cubre": "Mesh · knit · canvas · running", "Mesh y knit": "Se tratan igual", "Agua": "Sí, directo y sin miedo", "Cepillo": "SOFT", "Paso clave": "Espuma antes, enjuague después" },
      protocolo: [
        { t: "Cordones y plantilla fuera. <b>Cepillado en seco completo</b> — si mojas encima del polvo, lo conviertes en barro y lo metes entre los hilos.", seg: 60 },
        { t: "Golpea suela contra suela para botar lo suelto. Empieza por la suela y sube." },
        { t: "<b>Moja la tela directo con Shampoo.</b> Acá no hay que andar con paño: la tela se moja." },
        { t: "<b>Haz harta espuma</b> con la esponja o batiendo con la escobilla. El trabajo lo hace la espuma, no la fuerza." },
        { t: "Escobilla <b>SOFT en círculos</b>, parejo y sin apretar. Zona completa, de costura a costura." },
        { t: "<b>¿Es una running de varias capas?</b> Mete una esponja con espuma dentro y comprímela contra la pared: la espuma sale de adentro hacia afuera y arrastra la mugre atrapada entre las capas." },
        { t: "<b>Vapor</b> si la mancha es difícil. En tela funciona muy bien." },
        { t: "<b>Enjuaga solo con agua limpia</b>, muchas pasadas. Este paso decide si tu par queda blanco o amarillo." },
        { t: "Sombra, papel blanco adentro y hormador, hasta que se seque por completo." },
        { t: "<b>No juzgues el resultado con la zapatilla mojada.</b> Mojada se ve peor de lo que está. Seca primero, y recién ahí decide si hay que repetir." }
      ],
      nunca: ["Escobilla dura: no limpia la trama, la corta", "Cloro en canvas blanco: lo amarillea, hace lo contrario de lo que promete", "Secar al sol para blanquear: mismo resultado, amarillo", "Lavadora: despega la suela y satura la espuma", "Echarle más producto porque se ve peor mojada: el exceso de shampoo es justo lo que amarillea"],
      productos: ["Shampoo SneakClean", "Escobilla SOFT", "Sponge", "Quitamanchas Protocol", "Bubble", "SneakSole"],
      parar: "El gran enemigo de la tela es el tiempo: una mancha fresca sale casi siempre, pero el pasto o el barro de meses ya tiñeron la fibra y pasaron a ser el color del material. Si quedó amarillo, no le eches más shampoo — envuélvela en papel absorbente mojado y déjala secar con el papel encima."
    },
    {
      id: "gamuza", nombre: "Gamuza y cueros con pelo", cod: "CUE-02", sw: "sw-gamuza",
      resumen: "Gamuza, nubuck, gamuzón, reno y los bototos tipo Timberland. Nombres distintos, mismo material: todo lo que tiene pelito se limpia igual.",
      reconocer: "Pasa el dedo por encima. Si cambia de color por donde pasaste, o si queda la marca de tu dedo, es de este grupo. Si se ve liso y brillante y no pasa nada, es otro material.",
      debilidades: ["Mojar <b>solo un pedazo</b> deja una marca de agua con borde. O mojas el color completo, o no lo mojas", "El calor la endurece y ya no vuelve", "Suelta color: en pares de varios colores, el oscuro se corre al claro"],
      spec: { "Cubre": "Gamuza · nubuck · gamuzón · reno · bototos", "Absorción": "Muy alta", "Agua": "Sí, el color completo", "Cepillo": "SOFT y BRASS", "MEDIUM": "Sirve, no es el ideal", "Caso extremo": "Lija al agua 600–1000", "Frecuencia": "Cepillado c/uso" },
      protocolo: [
        { t: "Cordones y plantilla fuera. Cuenta los colores del par: si tiene varios, se trabaja <b>por color, del claro al oscuro</b>." },
        { t: "<b>Prueba del paño blanco</b> en una parte escondida. Si el paño sale con color, la gamuza suelta color: poca agua y un paño distinto por color." },
        { t: "<b>Cepillo suave en seco</b> por todo el par. Después el <b>Eraser</b> sobre las marcas. Muchos pares terminan acá.", seg: 60 },
        { t: "¿Pelo aplastado? <b>Brass</b>, como peineta, siempre en el mismo sentido. En colores claros con mucha delicadeza: el bronce puede manchar.", seg: 90 },
        { t: "Poco sucia: <b>Protocol directo sobre la mancha</b>, esperar, y después Bubble con escobilla SOFT en círculos parejos.", seg: 420 },
        { t: "Muy sucia: lo mismo, pero con <b>Shampoo concentrado</b> en vez de Bubble. Moja <b>el color completo</b>, nunca un pedazo, y nunca dos colores a la vez." },
        { t: "<b>Caso extremo — lija al agua.</b> Solo si el eraser y el brass ya fallaron: lija al agua <b>grano 600 a 1000</b>, mojada, presión mínima, sobre la mancha. Parte por la 1000 y baja solo si no cede. Estás sacando material, así que empareja toda la zona al final o te queda un parche." },
        { t: "<b>Saca el exceso con paño de microfibra.</b> Si dejas el quitamanchas puesto, quema el material y la mancha ya no sale nunca." },
        { t: "Secar a la <b>sombra</b>, con papel blanco y hormador dentro, <b>hasta que se seque por completo</b>. Nunca al sol." },
        { t: "Ya seca: <b>Eraser o brass otra vez</b> para devolver la textura, y peina todo el pelo en la misma dirección." },
        { t: "<b>Activate</b> a 10–15 cm hasta humedecer toda la gamuza. Humecta y evita que se destiña con el tiempo." }
      ],
      nunca: ["Mojar solo un pedazo: eso es lo que deja la marca, no el agua", "Dejar el quitamanchas sin sacar el exceso: quema el material", "Sol directo, estufa o secador: la endurecen para siempre", "Pasta de dientes: rapa el pelo y deja una calva brillante"],
      productos: ["Eraser", "Escobilla BRASS", "Escobilla SOFT", "SneakActivate", "Quitamanchas Protocol", "Bubble", "Shampoo SneakClean"],
      parar: "Si a la tercera pasada no salió, para. Grasa de auto, aceite viejo y tintas casi nunca salen del todo, e insistir solo gasta el pelo de alrededor — y eso sí es para siempre."
    },
    {
      id: "cuero", nombre: "Cuero liso y charol", cod: "CUE-01", sw: "sw-cuero",
      resumen: "El más fácil de todos. Napa no es otro cuero: es el apellido del cuero liso cuando es suave. Aguanta, perdona y responde rápido.",
      reconocer: "Ponle una gota de agua. Si se queda encima como perlita, es <b>cuero pintado</b> — el de casi todas las zapatillas. Si se pone oscurita y entra de a poco, es <b>cuero natural</b> y chupa. Anótate cuál tienes: importa para las manchas de tinta.",
      debilidades: ["Se agrieta si nunca lo hidratas, y la grieta no se cierra nunca", "El cuero pintado se pela en escamas cuando la capa de pintura se despega", "El calor lo quema y deja la marca para siempre"],
      spec: { "Cubre": "Liso · napa · plena flor · corregido · charol", "Dificultad": "El más fácil", "Cepillo": "SOFT o MEDIUM", "Paso clave": "Gel en cada lavado", "Frecuencia": "Express semanal" },
      protocolo: [
        { t: "<b>Express:</b> Wipes, o Bubble con escobilla, o la Sponge con un poco de agua. Paño de microfibra y listo." },
        { t: "<b>Profunda:</b> cordones y plantilla fuera. Empieza por <b>la suela y sube</b> — si limpias arriba primero, la mugre de la suela te salpica y repites todo." },
        { t: "Muy sucio: <b>Shampoo concentrado</b>, aplicado con escobilla o batido en espuma con la esponja. Normal: <b>Bubble</b> directo." },
        { t: "Refriega <b>en círculos</b> con escobilla <b>SOFT o MEDIUM</b>. Las dos sirven en cuero." },
        { t: "Saca el exceso con paño de microfibra." },
        { t: "<b>Gel con los dedos</b>, esparcido por todo el cuero. Déjalo reposar: el cuero lo absorbe solo.", seg: 300 },
        { t: "Secar a la sombra con hormador dentro, hasta que se seque por completo." }
      ],
      nunca: ["Secarlo con estufa, secador o sol: así se produce el cuero agrietado", "Detergente o lavaloza: le sacan los aceites y lo parten", "Aceite de oliva o crema de manos: se ponen rancios y lo manchan", "Acetona como limpiador general: solo con cotonito, en una mancha puntual y en cuero NO pintado", "Saltarse el Gel: es la mitad del trabajo"],
      productos: ["Gel", "Shampoo SneakClean", "Bubble", "Wipes", "Sponge", "Escobilla SOFT", "Hormador ajustable", "Sneaker Shield"],
      parar: "Las arrugas de la punta sí se sacan: hormador dentro, paño húmedo encima y plancha suave sobre el paño — la plancha nunca toca el cuero. Pero si ya está agrietado, no lo planches: el calor abre más las grietas."
    },
    {
      id: "sintetico", nombre: "Sintéticos", cod: "SIN-01", sw: "sw-sintetico",
      resumen: "Cuerina, microfibra, TPU, reflectante y neoprén. El más fácil de toda la guía: nada penetra, todo queda encima.",
      reconocer: "<b>Dóblalo.</b> El cuero de verdad hace pliegues suaves; el sintético hace un <b>quiebre duro y marcado</b>, como una hoja de papel. Y la gota de agua se queda redonda: no entra nunca.",
      debilidades: ["El calor lo deforma y lo despega — aguanta <b>menos</b> que el cuero, no más", "Cuando falla no es una mancha: es la capa que se despegó, y eso no se limpia", "Los solventes lo disuelven al toque"],
      spec: { "Cubre": "Cuerina · microfibra · TPU · 3M · neoprén", "Absorción": "Ninguna", "Dificultad": "El más fácil", "Cepillo": "SOFT siempre", "Su enemigo": "El calor" },
      protocolo: [
        { t: "<b>Paño húmedo con Shampoo diluido.</b> Para el 80% de los casos, con esto ya quedó listo." },
        { t: "¿Tiene textura? Espuma y <b>escobilla SOFT</b>. En sintéticos SOFT siempre: no hay ningún caso donde corresponda una más dura." },
        { t: "<b>Reflectante 3M:</b> solo paño suave, <b>sin cepillo de ningún tipo</b>. El reflejo son microesferas de vidrio pegadas — si lo frotas las arrancas y no vuelven." },
        { t: "<b>Microfibra:</b> parece gamuza pero no lo es. Se moja sin drama y <b>no lleva brass ni Activate</b>. Se distingue porque es perfectamente uniforme." },
        { t: "<b>Neoprén:</b> es una esponja. Enjuaga muy bien y sécalo lento y completo, o queda con olor a húmedo." },
        { t: "Secar a la sombra, lejos de cualquier fuente de calor." },
        { t: "<b>Gel opcional</b> en el liso, solo para dar brillo. Acá no alimenta nada: el sintético no tiene poros." }
      ],
      nunca: ["Calor de cualquier tipo: estufa, secador, sol o auto cerrado en verano", "Acetona, thinner o alcohol fuerte: lo disuelven al toque", "Esponja mágica o de melamina: no limpia, lija", "Cepillo duro: levanta el acabado", "Frotar el reflectante 3M: le arrancas el brillo para siempre"],
      productos: ["Shampoo SneakClean", "Escobilla SOFT", "Bubble", "Wipes", "Gel", "Paños de microfibra"],
      parar: "La cuerina que se pela no tiene vuelta, y ojo: <b>no se pela porque la lavaste, se pela porque le tocaba</b> — el poliuretano se descompone solo con la humedad y el tiempo, aunque el par esté guardado sin usar. Lo único que ayuda es no acelerarlo con calor."
    },
    {
      id: "suela", nombre: "Suelas y mediasuelas", cod: "SUE-01", sw: "sw-suela",
      resumen: "No es una suela, son tres: la goma de abajo, la espuma del medio y la banda. El amarillo casi siempre está en la del medio.",
      reconocer: "La <b>suela</b> es la goma dura que toca el suelo. La <b>mediasuela</b> es la espuma del medio, casi siempre blanca — ahí está el amarillo. La <b>banda</b> es la cinta de goma que rodea las vulcanizadas tipo Converse.",
      debilidades: ["El amarillo es <b>oxidación</b>, no suciedad: el material reacciona con el oxígeno y cambia cómo refleja la luz", "Las suelas traslúcidas o <i>icy</i> son las que peor amarillean; la vulcanizada es la que mejor resiste", "La mediasuela de poliuretano <b>se desarma sola</b> con los años, aunque nadie use el par"],
      spec: { "Cubre": "Goma · cristal · vulcanizada · EVA · PU · foam", "Cepillo": "MEDIUM", "Producto base": "SneakSole", "Orden": "Antes que el upper", "Antes de solventes": "Test del cotonito" },
      protocolo: [
        { t: "Cepillo <b>MEDIUM en seco</b> y un palito de madera para las piedras de las ranuras. Nada de metal: raya la goma.", seg: 60 },
        { t: "<b>Esto va antes que el upper.</b> Si limpias arriba primero, la mugre de abajo salpica y repites todo." },
        { t: "Shampoo y cepillo MEDIUM. Acá sí puedes insistir: la goma aguanta." },
        { t: "<b>SneakSole</b> para el amarillo y la oxidación de la mediasuela. Siempre se parte por acá.", seg: 300 },
        { t: "<b>⭐ ¿Vas a usar solvente? Haz el test primero.</b> Cotonito con alcohol en una parte escondida: si sale con color, la mediasuela está <b>pintada</b> y ahí no va ni alcohol ni acetona." },
        { t: "Escalera, siempre de suave a fuerte: <b>Shampoo → SneakSole → alcohol → acetona</b>. Si sale con el primero, no pases al segundo." },
        { t: "La <b>acetona solo en la goma de abajo</b>. Nunca en mediasuela pintada, foam blando, TPU transparente ni logos impresos." },
        { t: "Paño de microfibra y a secar. <b>Nunca sumerjas el par</b>: el agua entra por la unión y satura la espuma por semanas." }
      ],
      nunca: ["Sumergir el par: el agua satura la espuma de la mediasuela", "Cloro en mediasuela blanca: la amarillea más, hace lo contrario de lo que promete", "Solvente sin haber hecho el test del cotonito", "Esponja mágica: lija el brillo y la deja porosa, se ensucia el doble de rápido", "Lavadora: golpea la mediasuela y despega la suela"],
      productos: ["SneakSole", "Escobilla MEDIUM", "Shampoo SneakClean", "Paños de microfibra"],
      parar: "El amarillo <b>se administra, no se espera</b>: una mediasuela a la que le pasas SneakSole cada cierto tiempo nunca llega a ponerse fea. Cuando el material ya cambió en profundidad, la limpieza doméstica tiene un techo real — ahí es unyellowing profesional, con el upper protegido."
    },
    {
      id: "componentes", nombre: "Cordones y plantillas", cod: "COM-01", sw: "sw-canvas",
      resumen: "Lo que casi nadie lava, y es lo que más se nota. Los cordones cambian la percepción del par entero, y en la plantilla vive el olor.",
      reconocer: "No hay que identificar nada: <b>todos los pares los tienen</b>. Lo único que cambia es el tipo — cordón de algodón, poliéster o encerado; plantilla de espuma, memory foam u ortopédica.",
      debilidades: ["Los cordones sucios hacen que un par bien lavado se siga viendo sucio", "El olor <b>no está en el upper</b>: está en la plantilla, y por eso los aerosoles arriba no sirven", "El forro es una esponja: absorbe el sudor y no lo suelta"],
      spec: { "Por qué importa": "La mejor relación esfuerzo/resultado", "Cordones": "Bowl, 20–30 min de remojo", "Plantillas": "Paño y espuma, nunca sumergir", "Secado plantilla": "De canto, nunca plana", "No se remojan": "Encerados · memory foam · ortopédicas" },
      protocolo: [
        { t: "<b>Cordones fuera, siempre.</b> Nunca los laves puestos: se limpian a medias y dejas mugre en los ojetillos." },
        { t: "A un bowl con agua tibia y Shampoo diluido. <b>Déjalos remojando</b> — acá el trabajo lo hace el tiempo, no tú.", seg: 1200 },
        { t: "Frota entre las manos, <b>enjuaga muy bien</b> y cuélgalos a secar a la sombra. Si queda jabón se ponen tiesos y amarillean." },
        { t: "<b>¿Cordones blancos amarillos?</b> Casi siempre es residuo de jabón, no suciedad: remoja solo en agua limpia. Nunca cloro — los amarillea más y los deja quebradizos." },
        { t: "<b>Plantillas:</b> paño con espuma por las dos caras, sin empapar. Memory foam y ortopédicas <b>solo paño</b>: el agua y la torsión les destruyen la estructura." },
        { t: "<b>Sanitizer</b> en la plantilla y en el forro. Acá es donde de verdad se ataca el olor." },
        { t: "Seca las plantillas <b>de canto o paradas</b>, nunca planas sobre una mesa: la cara de abajo no seca y ahí sale el moho." },
        { t: "<b>Seca los ojetillos uno por uno.</b> Si quedan mojados se oxidan, y el óxido mancha la tela de alrededor." }
      ],
      nunca: ["Lavar los cordones puestos en la zapatilla", "Cloro en cordones blancos: los amarillea y los deja quebradizos", "Lavadora o secadora para las plantillas: se destruyen", "Meter la plantilla húmeda dentro del zapato: moho garantizado", "Perfume o aerosol sobre el upper para el olor: estás perfumando el lugar equivocado"],
      productos: ["Shampoo SneakClean", "Sanitizer", "Sneakclean Pills", "Escobilla SOFT"],
      parar: "Hay un punto donde limpiar ya no sirve: cuando la espuma de la plantilla quedó aplastada, cuando se ve la marca hundida del pie, o cuando el olor vuelve a los dos días de lavarla. Ahí se cambia — es barato y renueva el confort del par tanto como uno nuevo."
    },
    {
      id: "gorra", nombre: "Gorras", cod: "GOR-01", sw: "sw-knit",
      resumen: "Tiene dos problemas que ningún otro artículo tiene: pierde la forma, y le salen manchas blancas al secar. Los dos se resuelven en el secado, no en el lavado.",
      reconocer: "<b>Antes de tocar nada, dobla la visera y suéltala.</b> ¿Vuelve sola y suena seco? Es plástico, se moja sin problema. ¿Queda algo doblada y suena sordo? Es <b>cartón prensado</b> y no se sumerge nunca — el agua lo deshace por dentro y no vuelve.",
      debilidades: ["Las <b>manchas blancas</b> son sal del sudor más residuo de jabón, y aparecen siempre en el borde frontal y la banda de sudor", "La visera de cartón se deshace con el agua y no tiene arreglo", "Los <b>bordados destiñen</b> y se corren sobre la tela clara de al lado"],
      spec: { "Cubre": "Snapback · fitted · trucker · dad hat · lana", "Test previo": "Doblar la visera", "Cepillo": "SOFT", "Paso clave": "Banda de sudor primero, enjuague largo después", "Forma": "Globo, bowl, tarro o pelota" },
      protocolo: [
        { t: "<b>Prueba del paño blanco</b>, sobre todo en los bordados. Son el detalle que más gorras arruina." },
        { t: "Cepillado en seco con escobilla SOFT por toda la gorra." },
        { t: "<b>Ataca primero la banda de sudor</b> — la tira interior que roza tu frente. Ahí está concentrada toda la sal. Protocol, dejar actuar, cepillo suave.", seg: 300 },
        { t: "Ahora el resto con Shampoo y espuma, escobilla SOFT en círculos. <b>Moja la gorra completa</b>, nunca por zonas… salvo que tengas visera de cartón: ahí es espuma y paño, y la visera no se empapa." },
        { t: "<b>Enjuaga largo, solo con agua limpia.</b> Cambia el agua dos o tres veces, hasta que no salga espuma. Este es el paso que más gente acorta y el que produce las manchas blancas." },
        { t: "<b>Seca con forma:</b> globo inflado adentro (puedes ajustar el tamaño), bowl boca abajo, tarro, pelota semi-desinflada, o puesta en tu propia cabeza." },
        { t: "<b>La visera se moldea húmeda</b>, con elásticos alrededor de algo curvo. Nunca la fuerces en seco: ahí es cuando se quiebra." },
        { t: "Aire circulando para que seque parejo. Si seca despareja, el agua arrastra la sal hacia la zona húmeda y ahí se forma el borde blanco." }
      ],
      nunca: ["Sumergir una visera de cartón: se deshace por dentro y no vuelve", "Lavadora: deforma la copa y aplasta la visera", "Lavavajillas: circula como truco en internet y junta calor con detergente alcalino, que es justo lo que la destruye", "Colgarla mojada de un gancho: se estira la copa y queda la marca", "Tomarla de la visera: cada vez que lo haces la estás doblando"],
      productos: ["Shampoo SneakClean", "Quitamanchas Protocol", "Escobilla SOFT", "Sanitizer"],
      parar: "Si ya te salieron manchas blancas, no necesitas producto: <b>la sal se disuelve en agua</b>. Vuelve a mojar la gorra completa con agua limpia tibia, insiste con paño en la zona y enjuaga. Lo que no vuelve es el cartón de la visera que ya se deshizo, la lana encogida y el bordado que ya se corrió."
    },
    {
      id: "bolso", nombre: "Bolsos y mochilas", cod: "BOL-01", sw: "sw-canvas",
      resumen: "Bolso, mochila, banano, cartera. El material no es nuevo — es cuero, gamuza, lona o sintético. Lo que cambia es dónde se ensucia y cómo se seca.",
      reconocer: "No hay que identificar el bolso: hay que identificar <b>de qué está hecho</b>. Cuero liso o charol → cap. 2. Gamuza o nubuck → cap. 1. Lona o tela → cap. 3. Nylon, cuerina o sintético → cap. 4.",
      debilidades: ["No se ensucia parejo: se ensucia en <b>cuatro puntos</b> — asas, base, esquinas de abajo y el borde del cierre", "Los herrajes se oxidan si quedan mojados, y el óxido mancha la tela de al lado", "<b>No tiene horma.</b> Si lo guardas aplastado, se queda aplastado"],
      spec: { "Cubre": "Bolso · mochila · banano · cartera · neceser", "El material": "Ver capítulos 1 a 4", "Se limpia primero": "La base", "El punto olvidado": "Las asas", "Forma": "Se rellena, no hay hormador" },
      protocolo: [
        { t: "<b>Vacíalo completo</b>, incluidos los bolsillos que nunca abres. Dalo vuelta y sacúdelo, o pásale la aspiradora por dentro — esto saca más que cualquier producto." },
        { t: "<b>La base primero.</b> Es la suela del bolso: lo apoyas en el suelo, en el metro, en el piso del auto. Es lo más sucio de todo." },
        { t: "<b>Las asas después</b>, con más producto y más tiempo. Es la banda de sudor del bolso: la grasa de tus manos se acumula ahí todos los días." },
        { t: "El cuerpo, con el protocolo del material que sea." },
        { t: "<b>Herrajes: sécalos uno por uno.</b> Un cotonito para los rincones. Si el cierre cuesta, pásale la punta de un lápiz de grafito o un pedacito de vela — nunca aceite, que atrae mugre y mancha." },
        { t: "<b>Forro:</b> dalo vuelta si se puede. Si no, paño con espuma metiendo la mano, sin empapar: el forro va pegado y el exceso de agua lo despega." },
        { t: "<b>Rellénalo con papel blanco</b> arrugado sin apretar, y guárdalo de pie en bolsa de tela. Nunca diario: la tinta se pasa al forro." }
      ],
      nunca: ["<b>Colgar un bolso mojado de su asa</b>: el peso la estira y esa deformación no vuelve nunca", "Lavadora, ni siquiera para mochilas: despega el acolchado y oxida los herrajes", "Aceite en los cierres: atrae mugre y mancha la tela", "Dejar los herrajes mojados", "Rellenar con diario"],
      productos: ["Shampoo SneakClean", "Gel", "Escobilla SOFT", "Sanitizer", "Paños de microfibra"],
      parar: "Hay cuatro cosas que no vuelven: las asas de cuero oscurecidas por años de grasa de manos (eso ya es pátina y muchos la encuentran bonita), la tinta de lapicero en forro claro, las esquinas gastadas hasta el hilo, y el metal picado por óxido."
    }
  ];

  var STUBS = ["Denim", "Ripstop / nylon", "Corcho y yute", "Lana y fieltro"];

  var PROBLEMAS = [
    { id: "mugre",  n: "Suciedad general" },
    { id: "mancha", n: "Mancha puntual" },
    { id: "olor",   n: "Olor" },
    { id: "color",  n: "Color apagado o amarillo" }
  ];

  var GRAVEDAD = [
    { id: "leve",  n: "Reciente", d: "Menos de 24 h" },
    { id: "media", n: "Instalada", d: "Días o semanas" },
    { id: "alta",  n: "Antigua o extendida", d: "Meses, o cubre gran parte" }
  ];

  /* Protocolos del diagnóstico: material × problema */
  var DIAG = {
    mesh: {
      mugre:  { nivel: 0, res: "El trabajo lo hace la espuma, no la fuerza. La tela se moja directo y sin miedo.",
                pasos: ["Cordones y plantilla fuera, cepillado en seco completo", "Golpear suela contra suela y empezar por la suela", "Mojar directo con Shampoo y hacer harta espuma", "Escobilla SOFT en círculos, zona completa", "Running de varias capas: esponja con espuma desde adentro hacia afuera", "Enjuagar solo con agua limpia — sin esto el blanco queda amarillo", "Sombra y hormador, y no juzgar el resultado hasta que esté seca"],
                prods: ["Shampoo SneakClean", "Escobilla SOFT", "Sponge"] },
      mancha: { nivel: 1, res: "La malla retiene la mancha dentro de la trama. Necesita quitamanchas, no más fuerza.",
                pasos: ["Prueba de solidez de color en zona oculta", "Quitamanchas Protocol directo sobre la mancha", "Dejar actuar 3 min sin que se seque", "Cepillo SOFT en movimientos cortos", "Retirar y repetir máximo 3 veces"],
                prods: ["Quitamanchas Protocol", "Escobilla SOFT"] },
      olor:   { nivel: 0, res: "En malla el olor casi siempre está en la plantilla, no en el upper.",
                pasos: ["Saca la plantilla y lávala aparte", "Sanitizer en el interior, dejar ventilar", "Pills adentro por 48 h", "Rotar el par: no usarlo dos días seguidos"],
                prods: ["Sanitizer", "Sneakclean Pills"] },
      color:  { nivel: 1, res: "En textil sintético el amarillo casi siempre está en la mediasuela, no en la malla.",
                pasos: ["Identificar si el amarillo es del upper o de la mediasuela", "Si es mediasuela: SneakSole con cepillo MEDIUM", "Si es del textil: reenjuagar primero — suele ser residuo de jabón", "Secar a la sombra: el sol es lo que amarillea"],
                prods: ["SneakSole", "Escobilla MEDIUM"] }
    },
    gamuza: {
      mugre:  { nivel: 1, res: "Empieza en seco. Si el par sigue sucio, sí se moja — pero todo parejo, nunca por zonas.",
                pasos: ["Cepillo suave en seco por todo el par", "Eraser sobre las marcas: muchos pares terminan acá", "¿Pelo aplastado? Brass como peineta, un solo sentido", "¿Sigue sucio? Bubble con SOFT en círculos parejos", "Muy sucio: Shampoo concentrado y todo el par parejo", "Sacar el exceso con microfibra, sombra 24–48 h, y Activate al final"],
                prods: ["Eraser", "Escobilla SOFT", "Escobilla BRASS", "SneakActivate"] },
      mancha: { nivel: 1, res: "Prueba del paño blanco primero. Si el par tiene varios colores, se trabaja por color, del claro al oscuro.",
                pasos: ["Si es grasa fresca: talco o maicena encima, sin frotar, 30 min mínimo", "Eraser en seco sobre la marca", "Protocol directo sobre la mancha, esperar 5 a 10 min", "Bubble con escobilla SOFT, círculos parejos", "Sacar el exceso con microfibra — si lo dejas puesto, quema el material", "Vapor a 20 cm si la mancha es más difícil"],
                prods: ["Quitamanchas Protocol", "Bubble", "Escobilla SOFT", "Eraser"] },
      olor:   { nivel: 0, res: "El interior se trata igual en todos los materiales. El upper de gamuza ni se toca.",
                pasos: ["Plantilla fuera, lavado aparte", "Sanitizer solo en el interior", "Pills adentro por 48 h"],
                prods: ["Sanitizer", "Sneakclean Pills"] },
      color:  { nivel: 1, res: "La gamuza pierde tono por el roce, no por suciedad. Se reactiva, no se lava.",
                pasos: ["Brass en seco para levantar el pelo", "SneakActivate a 20 cm, pasadas parejas", "Secar y volver a cepillar", "Repel para proteger"],
                prods: ["SneakActivate", "Escobilla BRASS", "Repel"] }
    },
    cuero: {
      mugre:  { nivel: 0, res: "Limpieza suave por zonas completas y, sobre todo, hidratación después.",
                pasos: ["Paño seco para el polvo", "Shampoo diluido sobre el paño, no sobre el cuero", "Circular suave, zona por zona", "Gel hidratante en capa fina", "Lustrar con paño seco"],
                prods: ["Shampoo SneakClean", "Gel", "Paños de microfibra"] },
      mancha: { nivel: 1, res: "El cuero perdona menos que el textil. Prueba siempre en zona oculta.",
                pasos: ["Prueba de solidez de color obligatoria", "Quitamanchas Protocol sobre el paño, nunca directo", "Toques suaves, sin frotar", "Limpiar la zona completa, de costura a costura, para no dejar marca", "Hidratar con Gel al terminar"],
                prods: ["Quitamanchas Protocol", "Gel"] },
      olor:   { nivel: 0, res: "Mismo protocolo de interior. El cuero exterior no interviene.",
                pasos: ["Plantilla fuera", "Sanitizer en el interior", "Pills por 48 h", "Hormador para ventilar la horma"],
                prods: ["Sanitizer", "Sneakclean Pills", "Hormador ajustable"] },
      color:  { nivel: 2, res: "El cuero apagado no se limpia: se alimenta. El Gel devuelve brillo y profundidad, no pigmento.",
                pasos: ["Limpiar primero y evaluar cuánto era mugre y cuánto es desgaste", "Gel hidratante en capa fina, dejar penetrar 1 h", "Retirar el exceso y lustrar con paño seco", "Repetir 3 o 4 veces con 12 h entre cada una — el cuero absorbe de a poco", "Hormador dentro durante todo el proceso"],
                prods: ["Gel", "Paños de microfibra", "Hormador ajustable"] }
    },
    sintetico: {
      mugre:  { nivel: 0, res: "El más fácil de todos. Nada penetra, así que casi todo sale por encima.",
                pasos: ["Paño húmedo con Shampoo diluido — para el 80% de los casos basta", "¿Tiene textura? Espuma y escobilla SOFT, nunca una más dura", "Secar a la sombra, lejos de cualquier calor"],
                prods: ["Shampoo SneakClean", "Escobilla SOFT", "Paños de microfibra"] },
      mancha: { nivel: 0, res: "La mancha está encima, no adentro. Con paño y espuma sale casi siempre.",
                pasos: ["Grasa fresca: talco encima, aunque acá casi no penetra", "Paño húmedo con Shampoo, o Bubble directo", "Escobilla SOFT si hace falta, nunca más dura", "Marcas negras de roce: goma de borrar blanca, sin mojar", "Nada de acetona ni alcohol fuerte: en sintético lo disuelven al toque"],
                prods: ["Bubble", "Escobilla SOFT", "Shampoo SneakClean"] },
      olor:   { nivel: 0, res: "Mismo protocolo de interior de siempre. Ojo con el neoprén, que es esponja y guarda humedad.",
                pasos: ["Plantilla fuera, lavado aparte", "Sanitizer en el interior", "Pills por 48 h", "Si tiene neoprén: enjuagar muy bien y secar lento y completo"],
                prods: ["Sanitizer", "Sneakclean Pills"] },
      color:  { nivel: 1, res: "En sintético el color apagado suele ser el acabado rayado, no suciedad. El Gel empareja el brillo.",
                pasos: ["Limpiar primero y secar para ver el estado real", "Gel en capa fina sobre el sintético liso: solo da brillo, no alimenta", "Rayones finos en TPU: el Gel los disimula, igual que en el charol", "Reflectante 3M perdido: eso no vuelve, las microesferas se arrancaron"],
                prods: ["Gel", "Paños de microfibra"] }
    },
    suela: {
      mugre:  { nivel: 0, res: "Es donde más puedes insistir de todo el par. La goma aguanta.",
                pasos: ["Cepillo MEDIUM en seco y un palito de madera para las piedras", "Esto va antes que el upper, siempre", "Shampoo y cepillo MEDIUM, sin miedo", "Paño de microfibra y a secar", "Nunca sumerjas el par: el agua satura la espuma de la mediasuela"],
                prods: ["Escobilla MEDIUM", "Shampoo SneakClean"] },
      mancha: { nivel: 1, res: "Marcas negras de roce y manchas incrustadas. Se sube de a poco, del producto más suave al más fuerte.",
                pasos: ["Empieza por SneakSole: muchas salen ahí", "¿No salió? Test del cotonito con alcohol en zona escondida", "Si el cotonito sale con color, la mediasuela está PINTADA: nada de solventes", "Si no está pintada: alcohol primero, acetona solo si el alcohol falló", "La acetona solo en la goma de abajo, con cotonito y nunca empapando"],
                prods: ["SneakSole", "Escobilla MEDIUM"] },
      olor:   { nivel: 0, res: "El olor no vive en la suela. Está en la plantilla y el forro.",
                pasos: ["Plantilla fuera, lavado aparte", "Sanitizer en el interior", "Pills por 48 h"],
                prods: ["Sanitizer", "Sneakclean Pills"] },
      color:  { nivel: 1, res: "El amarillo es oxidación, no suciedad: el material reacciona con el oxígeno y cambia cómo refleja la luz.",
                pasos: ["Limpia primero: muchas veces lo que parece amarillo es solo mugre y sudor", "SneakSole, que es el producto específico para esto", "Repite si hace falta: mejor dos aplicaciones normales que una cargada", "Y después manténla — el amarillo se combate manteniendo, no esperando", "Si el material ya cambió en profundidad, eso es unyellowing profesional"],
                prods: ["SneakSole", "Escobilla MEDIUM"] }
    },
    componentes: {
      mugre:  { nivel: 0, res: "Es lo más fácil de todo el par y lo que más se nota. Veinte minutos de trabajo simple.",
                pasos: ["Cordones fuera — nunca los laves puestos", "A un bowl con agua tibia y Shampoo diluido, 20 a 30 min de remojo", "Frotar entre las manos, enjuagar muy bien y colgar a la sombra", "Plantillas: paño con espuma por las dos caras, sin empapar", "Secar las plantillas de canto, nunca planas sobre una mesa", "Secar los ojetillos uno por uno o se oxidan"],
                prods: ["Shampoo SneakClean", "Escobilla SOFT"] },
      mancha: { nivel: 1, res: "En cordones el remojo largo saca casi todo. Lo que no sale con tiempo, no sale con fuerza.",
                pasos: ["Remojo largo primero: el tiempo hace el trabajo", "Quitamanchas Protocol sobre la mancha puntual, dejar actuar", "Frotar el cordón contra sí mismo o con cepillo suave", "Enjuagar hasta que no salga espuma", "Si después de eso sigue marcado, cambiar el cordón sale más barato que la tarde que vas a perder"],
                prods: ["Quitamanchas Protocol", "Shampoo SneakClean"] },
      olor:   { nivel: 0, res: "Acá es donde de verdad se ataca el olor. No en el upper: en la plantilla y el forro.",
                pasos: ["Plantilla fuera y lavada por las dos caras con paño y espuma", "Sanitizer en la plantilla y en las paredes interiores", "Secar de canto, completamente, antes de volver a ponerla", "Pills adentro mientras el par descansa", "Rotar: no usar el mismo par dos días seguidos", "Si el olor vuelve a los dos días, la plantilla ya cumplió — cámbiala"],
                prods: ["Sanitizer", "Sneakclean Pills"] },
      color:  { nivel: 0, res: "Los cordones blancos que se pusieron amarillos casi nunca están sucios: tienen residuo de jabón.",
                pasos: ["Remojar solo en agua limpia, sin nada de producto", "Cambiar el agua un par de veces", "Enjuagar hasta que no salga espuma", "Colgar a la sombra, nunca al sol", "Nunca cloro: los amarillea más y los deja quebradizos"],
                prods: ["Shampoo SneakClean"] }
    },
    gorra: {
      mugre:  { nivel: 1, res: "Todo el resultado se juega en el secado, no en el lavado. Antes de mojar: dobla la visera para saber si es cartón.",
                pasos: ["Doblar la visera: si queda algo doblada y suena sordo, es cartón y NO se sumerge", "Prueba del paño blanco, sobre todo en los bordados", "Cepillado en seco con SOFT", "Banda de sudor primero: ahí está toda la sal", "Shampoo y espuma con SOFT, mojando la gorra completa", "Enjuague largo solo con agua limpia, cambiando el agua dos o tres veces", "Secar con forma: globo, bowl, tarro o pelota, con aire circulando"],
                prods: ["Shampoo SneakClean", "Escobilla SOFT", "Quitamanchas Protocol"] },
      mancha: { nivel: 1, res: "El bordado es el detalle que más gorras arruina: destiñe y se corre sobre la tela clara de al lado.",
                pasos: ["Prueba del paño blanco en el bordado antes de nada", "Si destiñe: poca agua, por zonas y con paños separados", "Protocol sobre la mancha, dejar actuar sin frotar", "Cepillo SOFT y retirar el exceso", "Enjuagar largo: el residuo de jabón se ve blanco al secar"],
                prods: ["Quitamanchas Protocol", "Escobilla SOFT"] },
      olor:   { nivel: 0, res: "El olor de una gorra vive en la banda de sudor, igual que en la plantilla de una zapatilla.",
                pasos: ["Banda de sudor con Protocol y cepillo suave", "Sanitizer en la banda y el interior de la copa", "Secar con forma y completamente", "Paño húmedo en la banda cada semana, como mantención"],
                prods: ["Sanitizer", "Quitamanchas Protocol"] },
      color:  { nivel: 0, res: "Las manchas blancas son sal del sudor más residuo de jabón. Y la sal se disuelve en agua: no necesitas producto.",
                pasos: ["Vuelve a mojar la gorra COMPLETA con agua limpia tibia", "Insiste con paño en la zona blanca", "Sal muy incrustada: vinagre blanco mitad y mitad, aplicado a la zona completa", "Enjuagar bien", "Secar con forma y con aire, para que seque parejo — el secado despareja es lo que forma el borde blanco"],
                prods: ["Shampoo SneakClean", "Paños de microfibra"] }
    },
    bolso: {
      mugre:  { nivel: 0, res: "No se ensucia parejo: se ensucia en cuatro puntos. Si atacas esos cuatro, el bolso ya se ve limpio.",
                pasos: ["Vaciarlo completo y sacudirlo o aspirarlo por dentro", "La base primero: es la suela del bolso", "Las asas después, con más producto y más tiempo", "El cuerpo, con el protocolo de su material", "Herrajes secados uno por uno", "Rellenar con papel blanco y guardar de pie"],
                prods: ["Shampoo SneakClean", "Escobilla SOFT"] },
      mancha: { nivel: 1, res: "En un bolso la mancha casi siempre está en el asa o en la base. El cuerpo suele estar más limpio de lo que parece.",
                pasos: ["Identifica el material y anda a su capítulo", "Asas: es grasa de manos, necesita tiempo de acción", "Tinta en el forro: alcohol en cotonito y un paño blanco por debajo para que la tinta migre al paño", "Cambia el paño en cada pasada", "En cuero, Gel al terminar"],
                prods: ["Quitamanchas Protocol", "Gel"] },
      olor:   { nivel: 0, res: "En mochilas el olor vive en el espaldar acolchado y las correas. Es esponja, igual que la plantilla de una zapatilla.",
                pasos: ["Vaciarlo y darlo vuelta si se puede", "Sanitizer en el espaldar, las correas y el forro", "Secado largo y completo, relleno y de pie", "Sílica adentro si vives en zona húmeda"],
                prods: ["Sanitizer", "Sneakclean Pills"] },
      color:  { nivel: 1, res: "El asa oscurecida no es suciedad: es grasa de las manos acumulada durante años. Se mejora, no se borra.",
                pasos: ["Limpieza a fondo del asa, con tiempo de acción", "En cuero, Gel para devolver brillo y emparejar el tono", "Repetir en varias sesiones separadas", "Aceptar que parte de eso ya es pátina del material"],
                prods: ["Gel", "Paños de microfibra"] }
    }
  };

  /* Los tres niveles describen cuánta técnica pide el trabajo, no si hay que
     delegarlo. Todo lo de la guía se hace en casa con el kit. */
  var VERDICTOS = [
    { k: "v-ok",   t: "Directo", d: "Protocolo simple. Con el kit sale a la primera." },
    { k: "v-warn", t: "Con técnica", d: "Se hace en casa igual, pero el orden importa. No te saltes pasos." },
    { k: "v-alto", t: "Delicado", d: "Se puede, y lo vas a lograr. Sin apuro, al pie de la letra, y sin insistir si no cede a la tercera pasada." }
  ];

  var RED_SEGURIDAD = 'Si es un par de mucho valor o prefieres no arriesgarte, también tenemos <a href="#">lavandería profesional</a>. Pero esto lo puedes hacer tú.';

  var MANCHAS = [
    { id:"barro", n:"Barro", nivel:0, grupo:"La calle",
      urgente:"No lo toques. Deja que se seque por completo — 12 h como mínimo. El barro húmedo se empuja hacia adentro de la fibra y ahí ya no sale.",
      noHacer:["Frotar en húmedo: lo mete en la trama","Agua a presión: lo dispersa por todo el upper","Papel absorbente: lo aplasta contra el material"],
      porMat:{"Telas":"Seco. Golpea suela contra suela, cepillo SOFT hasta sacar todo lo suelto, recién entonces espuma.","Gamuza":"Seco 24 h. Solo escobilla BRASS. Nada de agua en ningún momento.","Cuero":"Paño apenas húmedo por zonas completas, y Gel al terminar."},
      rendirse:"El barro rojizo con arcilla ferrosa sobre material claro tiñe y no vuelve del todo.",
      prods:["Escobilla SOFT","Escobilla BRASS","Shampoo SneakClean"] },

    { id:"pasto", n:"Pasto", nivel:1, grupo:"La calle",
      urgente:"No le eches agua: la fija. El pasto no es suciedad, es tinte vegetal — se comporta como una tintura, no como mugre.",
      noHacer:["Agua como primer paso","Calor de cualquier tipo","Frotar en seco"],
      porMat:{"Telas":"Protocol directo, dejar actuar, después espuma con SOFT.","Gamuza":"Brass en seco primero. Si persiste, Protocol al cepillo, nunca directo.","Cuero":"Protocol sobre el paño, toques suaves, y Gel al final."},
      rendirse:"El pasto viejo tiñe la fibra y queda de ese color. Esta hay que atacarla el mismo día, sin excepción.",
      prods:["Quitamanchas Protocol","Escobilla SOFT"] },

    { id:"cemento", n:"Cemento y cal", nivel:1, grupo:"La calle",
      urgente:"En seco, y no lo mojes bajo ningún concepto. El cemento fragua con el agua: si lo mojas, se endurece dentro del material.",
      noHacer:["Mojarlo, nunca","Dejarlo puesto: la cal es alcalina y quema el cuero","Cepillo duro sobre el polvo: raya el material"],
      porMat:{"Telas":"Cepillado en seco a fondo, sacudir, aspiradora si tienes. Recién sin polvo, limpieza normal.","Gamuza":"Brass en seco, con mucha paciencia.","Cuero":"Paño seco primero. Y Gel obligatorio: la cal reseca."},
      rendirse:"El cemento que ya fraguó dentro de la fibra no sale.",
      prods:["Escobilla SOFT","Shampoo SneakClean","Gel"] },

    { id:"betun", n:"Betún y alquitrán", nivel:2, grupo:"La calle",
      urgente:"Frío, no calor. Hielo en bolsa para endurecerlo y desprender lo que salga entero.",
      noHacer:["Frotar en caliente: lo extiende","Solventes sin probar en zona escondida","Insistir: gasta el material de alrededor"],
      porMat:{"Telas":"Endurecer, retirar, y el resto con Protocol y mucho tiempo de acción.","Gamuza":"Frío y brass. Sin líquido.","Suela de goma":"Acá sí puedes usar alcohol o acetona con cotonito."},
      rendirse:"El alquitrán en material poroso claro casi nunca sale del todo.",
      prods:["Quitamanchas Protocol","Escobilla SOFT"] },

    { id:"sal", n:"Sal de invierno", nivel:0, grupo:"La calle",
      urgente:"El mismo día, con agua tibia. La sal es higroscópica: atrae humedad de forma permanente al material y lo degrada desde adentro.",
      noHacer:["Dejarla para después","Cepillo en seco: la esparce","Agua caliente"],
      porMat:{"Telas":"Agua tibia, zona completa, y secar parejo. La sal se disuelve en agua: no necesitas producto.","Gamuza":"Vinagre blanco mitad y mitad con agua, al color completo, y brass al secar.","Cuero":"Paño húmedo, zona completa, y Gel al terminar."},
      rendirse:"Casi siempre sale. Si quedó marca, es la zona que secó despareja: vuelve a mojar completo.",
      prods:["Shampoo SneakClean","Paños de microfibra"] },

    { id:"roce", n:"Marcas de roce", nivel:0, grupo:"La calle",
      urgente:"No hay urgencia real: estas marcas son superficiales y salen casi siempre.",
      noHacer:["Abrasivos: rayan el acabado","Esponja mágica: deja el material poroso"],
      porMat:{"Telas":"Protocol y cepillo SOFT.","Cuero":"Muchas veces sale con goma de borrar blanca, sin mojar nada.","Banda de goma":"SneakSole."},
      rendirse:"Si la marca cortó el material en vez de depositarse encima, eso no es mancha: es desgaste.",
      prods:["Quitamanchas Protocol","SneakSole"] },

    { id:"aceite", n:"Aceite y grasa", nivel:2, grupo:"La mesa",
      urgente:"Absorber, no limpiar. Talco o maicena en capa gruesa, de 30 min a 12 h. El agua es lo peor que puedes echarle: la grasa no es soluble en agua y se expande.",
      noHacer:["Agua como primer paso: expande la mancha","Calor: fija la grasa de forma permanente","Frotar: la empuja hacia el interior"],
      porMat:{"Telas":"Retira el polvo, Protocol, 3 min de acción, cepillo SOFT, repetir. Puede tomar 3 sesiones.","Gamuza":"Solo talco y brass. Sin líquido en ningún caso.","Cuero":"Talco, luego Protocol sobre el paño y Gel obligatorio al final."},
      rendirse:"Grasa de auto, o cualquier aceite de más de 48 h en gamuza: ya penetró la fibra.",
      prods:["Quitamanchas Protocol","Escobilla SOFT","Gel"] },

    { id:"vino", n:"Vino tinto", nivel:1, grupo:"La mesa",
      urgente:"Absorber sin frotar, presionando con papel. Después agua fría abundante.",
      noHacer:["Agua caliente: fija el color","Frotar: lo extiende","Echarle sal encima: es mito, en textil solo deja residuo"],
      porMat:{"Telas":"Absorber, agua fría, y después Protocol con tiempo de acción.","Gamuza":"Absorber en seco. Brass. Líquido solo si no cede.","Cuero":"Paño apenas húmedo, zona completa, y Gel."},
      rendirse:"El vino de días en textil claro deja un tono rosado que suele quedarse.",
      prods:["Quitamanchas Protocol","Shampoo SneakClean"] },

    { id:"cafe", n:"Café y té", nivel:1, grupo:"La mesa",
      urgente:"Agua fría, harta y rápido. Son taninos — el mismo compuesto que se usa para teñir.",
      noHacer:["Agua caliente: fija el tanino","Dejarlo secar antes de actuar"],
      porMat:{"Telas":"Agua fría abundante, después Protocol.","Gamuza":"Absorber, secar, brass. Nada de agua directa.","Cuero":"Paño húmedo y Gel al terminar."},
      rendirse:"El café en gamuza clara con días encima ya tiñó.",
      prods:["Quitamanchas Protocol","Shampoo SneakClean"] },

    { id:"salsas", n:"Kétchup y salsas", nivel:1, grupo:"La mesa",
      urgente:"Retira lo sólido con una cuchara o el canto de una tarjeta, sin frotar. Después agua fría.",
      noHacer:["Frotar lo sólido: lo esparce","Agua caliente"],
      porMat:{"Telas":"Retirar, agua fría, Protocol.","Gamuza":"Retirar en seco, talco por la parte grasa, brass.","Cuero":"Paño húmedo y Gel."},
      rendirse:"Ojo: muchas salsas traen aceite y colorante a la vez. Talco primero para la grasa, y después ataca el color — en ese orden.",
      prods:["Quitamanchas Protocol","Escobilla SOFT"] },

    { id:"sangre", n:"Sangre", nivel:1, grupo:"El cuerpo",
      urgente:"Agua fría. Nunca tibia, nunca caliente. La sangre es proteína y el calor la cocina, fijándola para siempre.",
      noHacer:["Agua tibia o caliente: la fija de forma permanente","Frotar fuerte","Dejarla secar"],
      porMat:{"Telas":"Agua fría y toques suaves con paño blanco, cambiando de cara. Fresca sale casi entera.","Gamuza":"Dejar secar, brass, y goma de gamuza. Nada de agua.","Cuero":"Paño con agua fría, toques, y Gel al terminar."},
      rendirse:"La sangre vieja en cuero es de las más difíciles de toda la guía.",
      prods:["Shampoo SneakClean","Paños de microfibra"] },

    { id:"sudor", n:"Sudor amarillento", nivel:1, grupo:"El cuerpo",
      urgente:"No es urgente, es acumulativo: aparece con los meses en el interior, el borde del talón y la banda de sudor de las gorras.",
      noHacer:["Cloro: amarillea más","Perfume encima: tapa el olor pero no saca la mancha"],
      porMat:{"Interior":"Limpieza a fondo con espuma, enjuague largo y Sanitizer.","Gorras":"La banda de sudor se ataca primero y aparte del resto.","Plantillas":"Paño con espuma por las dos caras, y cambiarlas si el olor vuelve a los dos días."},
      rendirse:"Se evita mucho más fácil de lo que se saca: rotación de pares y Pills.",
      prods:["Sanitizer","Sneakclean Pills","Shampoo SneakClean"] },

    { id:"maquillaje", n:"Maquillaje", nivel:1, grupo:"El cuerpo",
      urgente:"Talco primero. Casi todos los maquillajes son pigmento más aceite: son dos manchas en una.",
      noHacer:["Atacar el color antes que la grasa","Agua como primer paso","Frotar"],
      porMat:{"Telas":"Talco, cepillar el polvo, y recién ahí Protocol para el pigmento.","Gamuza":"Talco y brass. Sin líquido.","Cuero":"Talco, Protocol sobre el paño, y Gel."},
      rendirse:"El autobronceante sobre material poroso claro tiñe.",
      prods:["Quitamanchas Protocol","Escobilla SOFT"] },

    { id:"tinta", n:"Tinta y lápiz pasta", nivel:2, grupo:"La casa",
      urgente:"Pon un paño blanco limpio DEBAJO de la tela y aplica alcohol con cotonito por arriba. La tinta migra hacia el paño en vez de expandirse por tu material.",
      noHacer:["Frotar: la extiende","Empapar","Usar un paño de color debajo: te tiñe encima"],
      porMat:{"Telas":"Paño blanco debajo, alcohol en cotonito, cambiando el paño en cada pasada.","Gamuza":"Brass en seco. El líquido acá empeora todo.","Cuero":"Si NO es pintado, acetona con cotonito. Si es pintado, no: te llevas la pintura."},
      rendirse:"La tinta rara vez sale del todo. A medias, casi siempre.",
      prods:["Quitamanchas Protocol","Paños de microfibra"] },

    { id:"pintura", n:"Pintura", nivel:2, grupo:"La casa",
      urgente:"Identifica cuál es antes de tocarla: la de agua (látex) fresca sale con agua; la de aceite (esmalte) necesita solvente.",
      noHacer:["Rascar en seco: raya el material","Solvente sin saber qué pintura es","Dejarla secar si es látex"],
      porMat:{"Látex fresca":"Agua fría y rápido. Sale casi entera.","Látex seca":"Ablandar con Protocol y mucho tiempo, retirar con cuidado.","Esmalte":"Necesita solvente, y el solvente daña casi todo material."},
      rendirse:"El esmalte seco sobre textil no sale sin dañar el material. Este es de los pocos casos donde conviene aceptarlo.",
      prods:["Quitamanchas Protocol"] },

    { id:"oxido", n:"Óxido", nivel:2, grupo:"La casa",
      urgente:"Atácalo antes de que se fije. Y busca la causa: casi siempre viene de los propios ojetillos del par, o de un herraje que quedó mojado.",
      noHacer:["Dejarlo: se fija en la fibra","Cloro: empeora la mancha"],
      porMat:{"Telas":"Protocol con tiempo de acción, varias sesiones.","Ojetillos":"El metal picado no vuelve, pero sí puedes atacar la mancha de alrededor.","Prevención":"Secar los ojetillos y herrajes uno por uno, siempre."},
      rendirse:"El óxido instalado en fibra clara es de los que menos sale.",
      prods:["Quitamanchas Protocol"] },

    { id:"cera", n:"Cera de vela", nivel:0, grupo:"La casa",
      urgente:"Frío. Hielo en bolsa hasta que la cera endurezca.",
      noHacer:["El truco del papel con plancha que se usa en ropa: acá el calor daña el material y derrite adhesivos","Rascar en tibio"],
      porMat:{"Telas":"Endurecer, quebrar y desprender entera. Lo que quede, Protocol.","Gamuza":"Endurecer, desprender, y brass.","Cuero":"Endurecer, retirar con el canto de una tarjeta, y Gel."},
      rendirse:"Si la cera era de color, el pigmento puede quedarse aunque la cera salga.",
      prods:["Quitamanchas Protocol"] },

    { id:"cadena", n:"Grasa de cadena", nivel:2, grupo:"La casa",
      urgente:"Talco o maicena, capa gruesa, sin frotar. Es grasa con pigmento negro: dos problemas en uno.",
      noHacer:["Agua primero","Frotar: esparce el negro","Calor"],
      porMat:{"Telas":"Talco, mucho tiempo, cepillar. Después Protocol para el pigmento, en varias sesiones.","Gamuza":"Talco y brass. Y expectativas bajas.","Cuero":"Talco, Protocol al paño, Gel."},
      rendirse:"En material claro y poroso, casi nunca sale del todo.",
      prods:["Quitamanchas Protocol","Escobilla SOFT"] },

    { id:"moho", n:"Moho y hongos", nivel:1, grupo:"Crecen solas",
      urgente:"Sácalo al aire libre antes de tocarlo. Si lo cepillas adentro de la casa, dispersas esporas por todas partes.",
      noHacer:["Trabajarlo puertas adentro","Guardar el par sin sanitizar","Volver a usar el mismo cepillo sin lavarlo"],
      porMat:{"Todos":"Cepillo seco al aire libre, shampoo, Sanitizer generoso, secado largo con papel cambiado dos veces, y Pills una semana.","Interior":"Es donde de verdad hay que insistir con el Sanitizer.","Prevención":"Nunca guardar un par que no esté 100% seco, y nunca en bolsa plástica sellada."},
      rendirse:"Si el moho está dentro de la espuma de la mediasuela y no en la superficie, el tratamiento casero no llega.",
      prods:["Sanitizer","Shampoo SneakClean","Sneakclean Pills"] },

    { id:"humo", n:"Amarillo por humo", nivel:1, grupo:"Crecen solas",
      urgente:"No hay urgencia: es acumulativo. Aparece en pares guardados donde se fuma o cerca de una cocina.",
      noHacer:["Cloro","Frotar fuerte: es una película grasa, no mugre pegada"],
      porMat:{"Telas":"Limpieza completa con espuma y enjuague muy largo. Sale con paciencia más que con fuerza.","Mediasuela":"SneakSole.","Interior":"Sanitizer y ventilación de días para el olor."},
      rendirse:"El amarillo de años en textil blanco mejora bastante pero rara vez vuelve al blanco original.",
      prods:["Shampoo SneakClean","SneakSole","Sanitizer"] },

    { id:"jeans", n:"Tinte de jeans", nivel:1, grupo:"Las comunes",
      urgente:"Actúa el mismo día. El índigo se fija con el tiempo y la luz — a las dos semanas ya es parte del material. Es la mancha número uno en zapatilla blanca.",
      noHacer:["Cloro: fija el índigo y encima amarillea el blanco","Frotar en seco: extiende la transferencia","Dejarlo para el fin de semana"],
      porMat:{"Telas":"Protocol directo, 2–3 min de acción, cepillo SOFT. Hasta 3 pasadas, sin saturar.","Gamuza":"Brass en seco, con paciencia y en varias sesiones. No pases a líquido.","Cuero":"Protocol sobre el paño, movimiento suave, zona completa. Gel al final."},
      rendirse:"Si lleva más de dos semanas en material poroso claro, el índigo ya se fijó. Limpia la zona completa para que quede pareja y no insistas sobre el punto.",
      prods:["Quitamanchas Protocol","Escobilla SOFT"] },

    { id:"chicle", n:"Chicle", nivel:0, grupo:"Las comunes",
      urgente:"Frío. Bolsa con hielo encima hasta que se endurezca por completo.",
      noHacer:["Tirar de él en tibio: se estira y se mete en la trama","Solvente como primer paso","Calor"],
      porMat:{"Todos":"Endurecer con hielo y desprender entero. Sale sin producto y sin frotar.","Si quedó residuo":"Protocol con tiempo de acción."},
      rendirse:"Casi siempre sale entero. Si el chicle era de color y tiñó, eso es otra mancha.",
      prods:["Quitamanchas Protocol"] },

    { id:"orina", n:"Orina de mascota", nivel:1, grupo:"Las comunes",
      urgente:"Absorbe todo lo que puedas de inmediato. Además del olor, la orina es ácida y va degradando el material mientras está ahí.",
      noHacer:["Dejarla: el ácido sigue trabajando","Solo perfumar: el problema es bacteriano","Agua caliente"],
      porMat:{"Todos":"Absorber, enjuague abundante con agua fría, limpieza completa y Sanitizer — que acá es lo importante.","Interior":"Plantilla fuera y lavada aparte, sí o sí."},
      rendirse:"Si el olor persiste después de dos tratamientos completos, los culpables son la plantilla y el forro. Cámbialos.",
      prods:["Sanitizer","Shampoo SneakClean","Sneakclean Pills"] },

    { id:"playa", n:"Alquitrán de playa", nivel:2, grupo:"Las comunes",
      urgente:"Frío para endurecerlo y retirar lo que salga entero. Y ojo: si vienes de la playa, además tienes sal.",
      noHacer:["Frotar en caliente","Olvidarte de la sal: enjuague con agua dulce el mismo día, siempre"],
      porMat:{"Telas":"Endurecer, retirar, y el resto con Protocol y mucho tiempo.","Gamuza":"Frío y brass. Sin líquido.","Suela de goma":"Alcohol con cotonito."},
      rendirse:"En material poroso claro, casi nunca sale del todo.",
      prods:["Quitamanchas Protocol","Escobilla SOFT"] }
  ];

  var MANCHAS_STUB = [];

  /* rec: 0 = se rescata · 1 = parcial · 2 = no tiene vuelta */
  var RESCATE = [
    {
      id: "cerco", n: "Marca de agua", rec: 0,
      pasó: "Limpiaste una mancha y ahora quedó un borde alrededor, como un aro más claro o más oscuro que el resto.",
      causa: "Mojaste solo un pedazo. El borde de la zona mojada se secó más lento y se llevó la mugre hacia afuera, y ahí quedó formando el aro. Es el error más común de todos y no tiene nada que ver con el producto que usaste.",
      pasos: [
        { t: "Vuelve a mojar <b>la zona completa</b>, de costura a costura. No la mancha: toda la zona." },
        { t: "Espuma pareja con Shampoo diluido, trabajando <b>del centro hacia el borde</b>." },
        { t: "Retira con paño húmedo escurrido, con la misma presión en todas partes." },
        { t: "Seca parejo, sin apuntar aire a un solo punto.", seg: 120 }
      ],
      evitar: "Nunca limpies solo la mancha. Siempre la zona entera, de costura a costura.",
      prods: ["Shampoo SneakClean", "Paños de microfibra"]
    },
    {
      id: "gamuza-mojada", n: "Gamuza mojada", rec: 0,
      pasó: "Le entró agua y quedó con el pelo aplastado, brillosa por partes y con manchas oscuras de borde marcado.",
      causa: "El agua colapsa las fibras del pelo y las pega entre sí. Al secar quedan planas y reflejan la luz distinto: eso es lo que ves como mancha. Se ve catastrófico y casi siempre vuelve — este es el caso donde más importa no entrar en pánico.",
      pasos: [
        { t: "<b>Sécala completa antes de tocarla.</b> Sombra, aire y papel adentro, hasta que esté seca por completo. Nada de calor. Si la intervienes húmeda, ahí sí la arruinas." },
        { t: "Ya seca: <b>escobilla BRASS</b>, movimientos cortos, una sola dirección. Vas a ver el pelo levantarse de nuevo.", seg: 180 },
        { t: "Insiste con paciencia sobre las zonas aplastadas." },
        { t: "Si quedaron marcas de agua: <b>vapor</b>. El par a 20 cm sobre agua hirviendo, unos segundos. Vapor, no agua. Cepilla de inmediato mientras está tibio." },
        { t: "<b>SneakActivate</b> para emparejar el tono al final." }
      ],
      evitar: "Impermeabilizante cada 4 semanas. La gamuza sin tratar y la lluvia no conviven.",
      prods: ["Escobilla BRASS", "SneakActivate", "Repel"]
    },
    {
      id: "amarillo", n: "Quedó más amarilla", rec: 0,
      pasó: "Lavaste un par blanco y al secarse quedó amarillento, sobre todo en la mediasuela.",
      causa: "Tres causas, y suelen venir juntas: la secaste al sol y el UV oxidó el material — esta es la número uno —, quedó residuo de jabón que amarillea al secar, o usaste cloro, que reacciona con los polímeros y produce amarillo permanente. El cloro hace exactamente lo contrario de lo que promete.",
      pasos: [
        { t: "<b>Reenjuaga bien.</b> Si era residuo, con esto basta: paño húmedo, agua limpia, varias pasadas hasta que no salga espuma." },
        { t: "Mediasuela y suela: <b>SneakSole</b>, dejar actuar, cepillo MEDIUM.", seg: 300 },
        { t: "Retirar y repetir si hace falta." },
        { t: "Secar <b>a la sombra</b>, con aire. Sin excepción." }
      ],
      evitar: "Sombra siempre. Enjuague completo siempre. Cloro nunca.",
      prods: ["SneakSole", "Escobilla MEDIUM", "Paños de microfibra"]
    },
    {
      id: "producto", n: "Producto equivocado", rec: 1,
      pasó: "Le echaste detergente, lavaloza, quitamanchas de supermercado, alcohol o acetona. Ahora hay una zona más clara, más oscura, mate o pegajosa.",
      causa: "Depende del producto: los alcalinos resecan y decoloran, los solventes disuelven el acabado, los blanqueadores ópticos dejan tono azulado bajo luz UV. La pregunta clave es si el daño es <b>residuo</b> — que sale — o <b>material disuelto</b> — que no. Pasa el dedo: si se siente pegajoso o jabonoso, es residuo. Si el material cambió de textura o de brillo, el acabado se fue.",
      pasos: [
        { t: "<b>Enjuague abundante</b> con agua limpia tibia y paño escurrido. Muchas pasadas, sin producto nuevo." },
        { t: "La zona completa, siempre. Nunca solo la mancha." },
        { t: "Secar y <b>evaluar recién a las 24 h</b>. No decidas nada sobre un par húmedo." },
        { t: "Si era cuero, hidrata con <b>Gel</b>: cualquier producto agresivo le sacó aceites." }
      ],
      evitar: "Nada que no esté hecho para calzado. Y test en zona oculta antes, siempre.",
      prods: ["Gel", "Paños de microfibra"]
    }
  ];

  var RESCATE_STUB = ["Se destiñó", "Suela despegada", "Olor a húmedo o moho", "Cuero quemado por calor", "Perdió la horma", "Encogió el forro", "Quedó rígida", "Rayé el charol", "Abrí la malla", "Visera deformada"];

  var REC = [["r-si", "Se rescata"], ["r-par", "Rescate parcial"], ["r-no", "No tiene vuelta"]];

  /* Columnas: Shampoo · Bubble · Gel · Activate · SneakSole · Protocol · SOFT · MEDIUM · BRASS
     La escobilla STIFF sale del catálogo: MEDIUM la reemplaza en suela y mediasuela. */
  var TABLA = [
    ["Telas (mesh/knit)",  ["si","si","no","no","no","si","si","cui","no"]],
    ["Canvas / lona",      ["si","si","no","no","no","si","si","si","no"]],
    ["Cuero liso",         ["cui","cui","si","no","no","cui","si","cui","no"]],
    ["Gamuza y con pelo",  ["cui","si","no","si","no","si","si","cui","si"]],
    ["Charol",             ["si","si","si","no","no","cui","si","cui","no"]],
    ["Cuerina / PU",       ["si","si","si","no","no","cui","si","no","no"]],
    ["Microfibra",         ["si","si","no","no","no","si","si","no","no"]],
    ["Reflectante 3M",     ["cui","cui","no","no","no","no","no","no","no"]],
    ["Gore-Tex",           ["cui","si","no","no","no","cui","si","no","no"]],
    ["Suela de goma",      ["si","si","no","no","si","si","si","si","no"]],
    ["Mediasuela EVA",     ["si","si","no","no","si","si","si","si","no"]],
    ["Mediasuela pintada", ["si","si","no","no","cui","no","si","cui","no"]],
    ["Cordones",           ["si","no","no","no","no","si","si","no","no"]],
    ["Plantillas",         ["si","no","no","no","no","cui","si","no","no"]],
    ["Gorra (tela)",       ["si","si","no","no","no","si","si","no","no"]],
    ["Gorra visera cartón",["cui","cui","no","no","no","cui","si","no","no"]]
  ];

  /* ---------------- Anatomía ---------------- */

  var ANATOMIA = {
    zapatilla: {
      viewBox: "0 0 440 250",
      silueta: "M 36,202 C 26,220 44,226 64,226 L 370,226 C 402,226 412,212 404,198 L 404,136 C 402,112 390,92 360,88 C 328,84 296,104 286,134 C 260,126 232,116 198,104 L 138,108 C 88,116 50,140 40,175 C 34,186 34,194 36,202 Z",
      /* d = forma clickeable · lx,ly = punto del número */
      partes: [
        { id: "capellada", es: "Capellada", en: "Upper", tone: "t3", lx: 168, ly: 140,
          d: "M 40,175 C 50,140 88,116 138,108 L 198,104 C 232,116 260,126 286,134 C 296,104 328,84 360,88 C 390,92 402,112 404,136 L 402,164 C 296,148 96,162 40,175 Z",
          desc: "Todo lo que va arriba de la suela: la parte que envuelve tu pie. Cuando alguien dice «el upper», habla de esto. Puede ser de cualquier material.",
          go: "Capítulos 1 a 4, según de qué esté hecha" },
        { id: "puntera", es: "Puntera", en: "Toe box", tone: "t3", lx: 84, ly: 146,
          d: "M 40,175 C 50,138 88,114 132,105 L 142,164 C 98,166 64,170 40,175 Z",
          desc: "La punta, donde van tus dedos. Es la zona que se dobla en cada paso y por eso es donde se marcan las arrugas.",
          go: "Capítulo 2 — el método de la plancha para sacarlas" },
        { id: "lengueta", es: "Lengüeta", en: "Tongue", tone: "t3", lx: 252, ly: 92,
          d: "M 216,106 C 218,82 230,68 248,62 L 268,58 C 276,80 282,108 286,132 C 262,124 240,114 216,106 Z",
          desc: "La tira que va debajo de los cordones. Por dentro es esponja: absorbe y no suelta, así que es lo último que se seca de todo el par.",
          go: "Capítulo 6 — no la empapes al lavar" },
        { id: "ojetillos", es: "Ojetillos", en: "Eyelets", tone: "t2", lx: 242, ly: 128,
          d: "M 200,106 L 286,136 L 282,148 L 196,118 Z",
          desc: "Los agujeros por donde pasan los cordones. Si son metálicos hay que secarlos uno por uno: si quedan mojados se oxidan, y el óxido mancha la tela de alrededor.",
          go: "Capítulo 6" },
        { id: "collar", es: "Collar", en: "Collar", tone: "t3", lx: 344, ly: 104,
          d: "M 286,134 C 296,104 328,84 360,88 C 390,92 402,112 404,136 L 386,138 C 384,118 368,104 348,106 C 326,110 306,118 296,140 Z",
          desc: "El borde acolchado que rodea tu tobillo. Está relleno de espuma, así que también guarda humedad.",
          go: "Capítulo 6 — se trata como el forro" },
        { id: "contrafuerte", es: "Contrafuerte", en: "Heel counter", tone: "t3", lx: 374, ly: 144,
          d: "M 348,106 C 372,110 388,130 394,152 L 402,164 C 382,158 360,153 340,149 Z",
          desc: "El refuerzo rígido del talón. Es el que mantiene la forma de atrás, y cuando se vence el par se ve caído por más limpio que esté.",
          go: "Capítulo 6 — y hormador al guardar" },
        { id: "mediasuela", es: "Mediasuela", en: "Midsole", tone: "t2", lx: 200, ly: 182,
          d: "M 38,176 C 28,196 30,202 36,202 L 404,198 C 414,182 408,166 396,164 C 296,148 96,162 38,176 Z",
          desc: "La espuma que va entre la suela y la capellada. Casi siempre es blanca, y es acá donde aparece el amarillo — no en la suela.",
          go: "Capítulo 5 — SneakSole" },
        { id: "suela", es: "Suela", en: "Outsole", tone: "t1", lx: 200, ly: 212,
          d: "M 36,202 C 26,220 44,226 64,226 L 370,226 C 402,226 412,212 404,198 Z",
          desc: "La goma dura que toca el suelo. Es lo más sucio del par y por eso se limpia primero, antes que todo lo demás.",
          go: "Capítulo 5" }
      ],
      extra: [
        ["Cordones", "Laces", "Lo que más cambia la percepción del par entero"],
        ["Herrete", "Aglet", "La puntita rígida del cordón. Cuando se rompe, el cordón se deshilacha"],
        ["Forro", "Lining", "La tela de adentro que roza tu pie. Funciona como esponja"],
        ["Plantilla", "Insole · Sockliner", "La que puedes sacar. Ahí vive el olor, no en el upper"],
        ["Talonera", "Heel tab", "La lengüeta de atrás para calzarse"],
        ["Banda de goma", "Foxing tape", "La cinta que rodea las vulcanizadas tipo Converse"],
        ["Refuerzos", "Overlays", "Las piezas pegadas encima de la capellada, muchas veces de otro material"]
      ]
    },

    bolso: {
      viewBox: "0 0 320 270",
      silueta: "M 70,102 C 70,74 92,60 118,60 L 138,60 C 138,42 150,34 160,34 C 170,34 182,42 182,60 L 202,60 C 228,60 250,74 250,102 L 250,208 C 250,228 236,236 218,236 L 102,236 C 84,236 70,228 70,208 Z",
      partes: [
        { id: "cuerpo", es: "Cuerpo", en: "Body", tone: "t3", lx: 160, ly: 126,
          d: "M 70,102 C 70,74 92,60 118,60 L 202,60 C 228,60 250,74 250,102 L 250,208 C 250,228 236,236 218,236 L 102,236 C 84,236 70,228 70,208 Z",
          desc: "La parte principal. Acá el material puede ser cualquiera: cuero, gamuza, lona o sintético. Para saber con qué limpiarlo, anda al capítulo de su material.",
          go: "Capítulos 1 a 4, según de qué esté hecho" },
        { id: "asa", es: "Asa", en: "Handle", tone: "t2", lx: 160, ly: 44,
          d: "M 138,60 C 138,42 150,34 160,34 C 170,34 182,42 182,60 L 172,60 C 172,48 166,44 160,44 C 154,44 148,48 148,60 Z",
          desc: "Es la banda de sudor del bolso: la grasa de tus manos se acumula ahí todos los días y por eso se pone más oscura y brillosa que el resto. Se limpia primero y aparte, con más producto y más tiempo.",
          go: "Capítulo 8 — el punto que más se olvida" },
        { id: "correas", es: "Correas", en: "Straps", tone: "t2", lx: 84, ly: 150,
          d: "M 88,92 C 66,112 60,152 66,198 L 84,194 C 78,154 84,120 100,102 Z",
          desc: "En mochilas guardan sudor igual que la plantilla de una zapatilla, sobre todo la parte acolchada. Sanitizer y secado completo.",
          go: "Capítulo 8" },
        { id: "cierre", es: "Cierre", en: "Zipper", tone: "t2", lx: 160, ly: 102,
          d: "M 74,106 C 100,88 220,88 246,106 L 244,118 C 218,100 102,100 76,118 Z",
          desc: "El canal del cierre junta pelusa e hilachas: un cepillo de dientes viejo saca una cantidad sorprendente. Si cuesta, pásale la punta de un lápiz de grafito o un pedacito de vela. Nunca aceite: atrae mugre y mancha.",
          go: "Capítulo 8" },
        { id: "bolsillo", es: "Bolsillo frontal", en: "Front pocket", tone: "t2", lx: 160, ly: 186,
          d: "M 92,152 L 228,152 L 228,210 C 228,218 222,222 214,222 L 106,222 C 98,222 92,218 92,210 Z",
          desc: "Vacíalo antes de empezar, incluso los que nunca abres. Dar vuelta el bolso y sacudirlo saca más suciedad que cualquier producto.",
          go: "Capítulo 8" },
        { id: "base", es: "Base", en: "Base", tone: "t1", lx: 160, ly: 228,
          d: "M 70,208 L 250,208 L 250,216 C 250,230 236,236 218,236 L 102,236 C 84,236 70,230 70,216 Z",
          desc: "Es la suela del bolso: lo apoyas en el suelo, en el metro, en el piso del auto. Es lo más sucio de todo y por eso se limpia antes que el cuerpo.",
          go: "Capítulo 8 — se limpia primero" },
        { id: "herrajes", es: "Herrajes", en: "Hardware", tone: "t1", lx: 243, ly: 192,
          d: "M 232,182 L 252,182 L 252,200 L 232,200 Z",
          desc: "Hebillas, argollas y mosquetones. La regla es una sola: nunca los dejes mojados. Se oxidan, y el óxido deja una mancha café en la tela de al lado que después no sale.",
          go: "Capítulo 8 — secarlos uno por uno" }
      ],
      extra: [
        ["Forro interior", "Lining", "Va pegado: paño con espuma, nunca empapar o se despega"],
        ["Espaldar acolchado", "Back panel", "En mochilas. Es esponja y guarda sudor"],
        ["Refuerzo de esquina", "Corner reinforcement", "Donde más se gasta el material"],
        ["Tirador del cierre", "Zipper pull", "Si se rompe, un llavero o una argolla lo reemplaza"],
        ["Bandolera", "Shoulder strap", "La correa larga. Nunca cuelgues el bolso mojado de ella"]
      ]
    },

    gorra: {
      viewBox: "0 0 380 250",
      silueta: "M 26,182 C 20,194 34,200 58,198 L 150,186 C 168,182 176,172 174,166 L 306,166 L 306,158 C 306,80 264,48 208,48 C 152,48 108,80 108,158 L 108,158 C 74,158 34,168 26,182 Z",
      partes: [
        { id: "copa", es: "Copa", en: "Crown", tone: "t3", lx: 208, ly: 96,
          d: "M 108,158 C 108,80 152,48 208,48 C 264,48 306,80 306,158 Z",
          desc: "La parte que cubre tu cabeza. Está formada por gajos cosidos: por eso se habla de gorras de 5 o de 6 paneles.",
          go: "Capítulo 7" },
        { id: "frontal", es: "Panel frontal", en: "Front panel", tone: "t3", lx: 150, ly: 118,
          d: "M 108,158 C 108,88 140,54 190,48 L 194,158 Z",
          desc: "Donde va el bordado o el logo. Ojo: los bordados destiñen y se corren sobre la tela clara de al lado, así que hazles la prueba del paño blanco antes.",
          go: "Capítulo 7" },
        { id: "visera", es: "Visera", en: "Brim · Bill", tone: "t1", lx: 62, ly: 178,
          d: "M 108,158 C 74,158 34,168 26,182 C 20,194 34,200 58,198 L 150,186 C 172,180 178,166 174,158 Z",
          desc: "La que da sombra. Puede ser de plástico o de cartón prensado, y eso decide si tu gorra se puede sumergir o no. Dóblala: si vuelve sola y suena seco es plástico; si queda algo doblada y suena sordo, es cartón.",
          go: "Capítulo 7 — el test antes de mojar nada" },
        { id: "banda", es: "Banda de sudor", en: "Sweatband", tone: "t2", lx: 208, ly: 164,
          d: "M 108,152 L 306,152 L 306,166 L 108,166 Z",
          desc: "La tira interior que roza tu frente. Acá se concentra toda la sal del sudor, y esa sal es la que después aparece como manchas blancas al secar.",
          go: "Capítulo 7 — se ataca primero, antes que el resto" },
        { id: "boton", es: "Botón", en: "Button · Squatchee", tone: "t2", lx: 208, ly: 40,
          d: "M 200,40 A 8 8 0 1 0 216,40 A 8 8 0 1 0 200,40 Z",
          desc: "El botoncito de arriba, donde se juntan todos los paneles. Es puro detalle, pero si es forrado en tela se ensucia igual que el resto.",
          go: "Capítulo 7" },
        { id: "ojales", es: "Ojales de ventilación", en: "Eyelets · Vents", tone: "t2", lx: 258, ly: 92,
          d: "M 246,84 A 8 8 0 1 0 262,84 A 8 8 0 1 0 246,84 Z",
          desc: "Los agujeritos de la copa que dejan salir el calor. A veces son bordados y a veces metálicos; si son metálicos, sécalos.",
          go: "Capítulo 7" },
        { id: "cierre", es: "Cierre", en: "Closure", tone: "t2", lx: 316, ly: 140,
          d: "M 306,120 L 330,120 L 330,158 L 306,158 Z",
          desc: "Va atrás y define el tipo de gorra: snapback si son broches, strapback si es una correa, y fitted si no tiene cierre porque viene en tallas.",
          go: "Capítulo 7" }
      ],
      extra: [
        ["Paneles", "Panels", "Los gajos cosidos que forman la copa. 5 o 6 según el modelo"],
        ["Ribete", "Taping", "La cinta que cubre las costuras por dentro"],
        ["Costura superior", "Top stitching", "La costura visible que recorre cada panel"],
        ["Malla trasera", "Mesh back", "La rejilla de las gorras trucker"]
      ]
    }
  };

  /* ------------------------------------------------------------------
     Anatomía: a qué capítulo de la web manda cada parte.
     El prototipo numeraba por el libro (1 = gamuza … 8 = bolsos) y la web
     numera distinto, así que acá se traduce y de paso se vuelve link.
     [null, texto] = sin link, cuando no hay un capítulo único al que ir.
  ------------------------------------------------------------------ */
  var GO = {
    zapatilla: {
      capellada:    [null,          "Capítulos 03 a 06, según de qué esté hecha"],
      puntera:      ["cuero-liso",  "Cuero liso — el método de la plancha para las arrugas"],
      lengueta:     ["componentes", "Cordones y plantillas — no la empapes al lavar"],
      ojetillos:    ["componentes", "Cordones y plantillas"],
      collar:       ["componentes", "Cordones y plantillas — se trata como el forro"],
      contrafuerte: ["componentes", "Cordones y plantillas — y hormador al guardar"],
      mediasuela:   ["suelas",      "Suelas y mediasuelas — SneakSole"],
      suela:        ["suelas",      "Suelas y mediasuelas"]
    },
    bolso: {
      cuerpo:    [null,     "Capítulos 03 a 06, según de qué esté hecho"],
      asa:       ["bolsos", "Bolsos y mochilas — el punto que más se olvida"],
      correas:   ["bolsos", "Bolsos y mochilas"],
      cierre:    ["bolsos", "Bolsos y mochilas"],
      bolsillo:  ["bolsos", "Bolsos y mochilas"],
      base:      ["bolsos", "Bolsos y mochilas — se limpia primero"],
      herrajes:  ["bolsos", "Bolsos y mochilas — secarlos uno por uno"]
    },
    gorra: {
      copa:     ["gorras", "Gorras"],
      frontal:  ["gorras", "Gorras"],
      visera:   ["gorras", "Gorras — el test antes de mojar nada"],
      banda:    ["gorras", "Gorras — se ataca primero, antes que el resto"],
      boton:    ["gorras", "Gorras"],
      ojales:   ["gorras", "Gorras"],
      cierre:   ["gorras", "Gorras — snapback, strapback o fitted"]
    }
  };

  /* ---------------- Utilidades ---------------- */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function clear(n) { while (n.firstChild) n.removeChild(n.firstChild); }
  function press(group, target) {
    var all = group.querySelectorAll("[aria-pressed]");
    for (var i = 0; i < all.length; i++) {
      all[i].setAttribute("aria-pressed", all[i] === target ? "true" : "false");
    }
  }
  function fmt(s) {
    var m = Math.floor(s / 60), r = s % 60;
    return m + ":" + (r < 10 ? "0" : "") + r;
  }

  /* Los temporizadores viven mientras la herramienta esté en pantalla. Si el
     lector cambia de capítulo hay que apagarlos o siguen corriendo invisibles. */
  var relojes = [];
  function apagaRelojes() {
    for (var i = 0; i < relojes.length; i++) clearInterval(relojes[i]);
    relojes = [];
  }

  function makeTimer(seg) {
    var b = el("button", "gm-timer");
    b.type = "button";
    b.textContent = "▶ " + fmt(seg);
    var left = seg, id = null;
    b.addEventListener("click", function () {
      if (id) {
        clearInterval(id); id = null;
        b.removeAttribute("data-running");
        b.textContent = "▶ " + fmt(left);
        return;
      }
      if (b.getAttribute("data-done") === "true") { b.removeAttribute("data-done"); left = seg; }
      b.setAttribute("data-running", "true");
      b.textContent = fmt(left);
      id = setInterval(function () {
        left--;
        if (left <= 0) {
          clearInterval(id); id = null; left = seg;
          b.removeAttribute("data-running");
          b.setAttribute("data-done", "true");
          b.textContent = "✓ listo";
        } else {
          b.textContent = fmt(left);
        }
      }, 1000);
      relojes.push(id);
    });
    return b;
  }

  /* El aviso de taller sale del editor de temas: sin URL no se muestra el link,
     que es mejor que dejar un href="#" muerto en producción. */
  function redSeguridad() {
    var url = (window.GUIA_LAVANDERIA_URL || "").trim();
    var txt = url
      ? 'Si es un par de mucho valor o prefieres no arriesgarte, también tenemos ' +
        '<a href="' + url + '">lavandería profesional</a>. Pero esto lo puedes hacer tú.'
      : 'Si es un par de mucho valor o prefieres no arriesgarte, también está la ' +
        'lavandería profesional. Pero esto lo puedes hacer tú.';
    return el("p", "gm-red", txt);
  }

  function bloque(t) { return el("div", "gm-block-title", t); }

  function listaProds(items) {
    var pr = el("div", "gm-prods");
    items.forEach(function (p) { pr.appendChild(el("span", "gm-prod", p)); });
    return pr;
  }

  /* pasos = strings sueltos o {t, seg}. El segundo caso lleva temporizador. */
  function listaPasos(pasos) {
    var ol = el("ol", "gm-proto");
    pasos.forEach(function (p) {
      var li = el("li");
      li.appendChild(el("span", "gm-txt", typeof p === "string" ? p : p.t));
      li.appendChild(typeof p !== "string" && p.seg ? makeTimer(p.seg) : el("span"));
      ol.appendChild(li);
    });
    return ol;
  }

  function cajaParar(rotulo, texto) {
    var pz = el("div", "gm-parar");
    pz.appendChild(el("p", null, "<strong>" + rotulo + ":</strong> " + texto));
    return pz;
  }

  /* ---------------- 1 · Anatomía ---------------- */

  var SVGNS = "http://www.w3.org/2000/svg";

  function svgEl(tag, attrs) {
    var n = document.createElementNS(SVGNS, tag);
    for (var k in attrs) if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]);
    return n;
  }

  function montaAnatomia(host, irA) {
    var figActual = "zapatilla";

    var tabs = el("div", "gm-anat-tabs");
    tabs.setAttribute("role", "group");
    tabs.setAttribute("aria-label", "Elegir artículo");

    var caja  = el("div", "gm-anat");
    var fig   = el("div", "gm-anat-fig");
    var info  = el("div", "gm-anat-info");
    caja.appendChild(fig); caja.appendChild(info);

    var wrapTabla = el("div", "gm-tabla-wrap gm-anat-lista");
    var tabla = el("table");
    tabla.innerHTML = "<thead><tr><th scope='col'>En español</th>" +
                      "<th scope='col'>En inglés</th><th scope='col'>Qué es</th></tr></thead>";
    var tbody = el("tbody");
    tabla.appendChild(tbody);
    wrapTabla.appendChild(tabla);

    function muestraParte(p, num) {
      clear(info);
      info.appendChild(el("div", "gm-eyebrow", "Parte " + num));
      info.appendChild(el("div", "gm-es", p.es));
      info.appendChild(el("div", "gm-en", p.en));
      info.appendChild(el("p", "gm-d", p.desc));

      var ref = (GO[figActual] || {})[p.id];
      var destino = ref ? ref[0] : null;
      var texto   = ref ? ref[1] : p.go;
      var go = el("div", "gm-go");
      if (destino) {
        var a = el("a", null, "→ " + texto);
        a.href = "#" + destino;
        a.addEventListener("click", function (e) { e.preventDefault(); irA(destino, true); });
        go.appendChild(a);
      } else {
        go.innerHTML = "→ " + texto;
      }
      info.appendChild(go);
    }

    function pinta(clave) {
      figActual = clave;
      var f = ANATOMIA[clave];
      clear(fig); clear(tbody); clear(info);

      var svg = svgEl("svg", { viewBox: f.viewBox, class: "gm-anat-svg", role: "img",
                               "aria-label": "Partes de la " + clave });
      if (f.silueta) svg.appendChild(svgEl("path", { d: f.silueta, class: "gm-silueta" }));

      f.partes.forEach(function (p, i) {
        var g = svgEl("g", { class: "gm-part", "data-id": p.id, tabindex: "0",
                             role: "button", "aria-label": p.es });
        g.appendChild(svgEl("path", { d: p.d, class: "gm-part-shape gm-" + (p.tone || "t2") }));
        g.appendChild(svgEl("circle", { cx: p.lx, cy: p.ly, r: 11, class: "gm-part-dot" }));
        var t = svgEl("text", { x: p.lx, y: p.ly + 3.5, class: "gm-part-num", "text-anchor": "middle" });
        t.textContent = String(i + 1);
        g.appendChild(t);

        function abrir() {
          var todos = svg.querySelectorAll(".gm-part");
          for (var j = 0; j < todos.length; j++) todos[j].removeAttribute("data-on");
          g.setAttribute("data-on", "true");
          muestraParte(p, i + 1);
        }
        g.addEventListener("click", abrir);
        g.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); abrir(); }
        });
        svg.appendChild(g);
      });

      fig.appendChild(svg);

      f.extra.forEach(function (row) {
        var tr = el("tr");
        row.forEach(function (celda) { tr.appendChild(el("td", null, celda)); });
        tbody.appendChild(tr);
      });

      info.appendChild(el("p", "gm-anat-hint", "Toca una parte del dibujo para ver cómo se llama."));
    }

    [["zapatilla", "Zapatilla"], ["gorra", "Gorra"], ["bolso", "Mochila"]].forEach(function (par, i) {
      var b = el("button", "gm-anat-tab", par[1]);
      b.type = "button";
      b.setAttribute("aria-pressed", i === 0 ? "true" : "false");
      b.addEventListener("click", function () { press(tabs, b); pinta(par[0]); });
      tabs.appendChild(b);
    });

    host.appendChild(tabs);
    host.appendChild(caja);
    host.appendChild(wrapTabla);
    pinta("zapatilla");
  }

  /* ---------------- 2 · Diagnóstico ---------------- */

  function montaDiagnostico(host) {
    var sel = { material: null, problema: null, gravedad: null };

    var caja  = el("div", "gm-diag");
    var pasos = el("div", "gm-diag-steps");

    function paso(num, titulo, etiqueta) {
      var d = el("div", "gm-diag-step");
      d.setAttribute("data-step", String(num));
      var lab = el("div", "gm-step-label");
      lab.appendChild(el("span", "gm-step-num", String(num)));
      lab.appendChild(el("h3", null, titulo));
      d.appendChild(lab);
      var chips = el("div", "gm-chips");
      chips.setAttribute("role", "group");
      chips.setAttribute("aria-label", etiqueta);
      d.appendChild(chips);
      pasos.appendChild(d);
      return { caja: d, chips: chips };
    }

    var p1 = paso(1, "¿De qué material es?",     "Material");
    var p2 = paso(2, "¿Qué le pasa?",            "Problema");
    var p3 = paso(3, "¿Qué tan grave está?",     "Gravedad");
    p2.caja.setAttribute("data-locked", "true");
    p3.caja.setAttribute("data-locked", "true");

    /* El paso 1 es donde se traba quien más necesita la guía: si supiera el
       material, no la necesitaría. Jack mira la foto y lo resuelve. Solo
       aparece si el widget de Jack está cargado en la página. */
    if (typeof window.jackAbrir === "function") {
      var ayuda = el("button", "gm-no-se", "📷 No sé de qué material es — que Jack mire una foto");
      ayuda.type = "button";
      ayuda.addEventListener("click", function () {
        window.jackAbrir({
          foto: true,
          texto: "¿De qué material son? No sé cuál elegir en el diagnóstico de la guía.",
        });
      });
      p1.caja.appendChild(ayuda);
    }

    var out   = el("div", "gm-resultado");
    var vacio = el("p", "gm-empty", "Elige un material para empezar.");
    out.hidden = true;

    caja.appendChild(pasos);
    caja.appendChild(out);
    caja.appendChild(vacio);
    host.appendChild(caja);

    MATERIALES.forEach(function (m) {
      var b = el("button", "gm-chip gm-chip-sw");
      b.type = "button";
      b.setAttribute("aria-pressed", "false");
      b.appendChild(el("span", "gm-swatch gm-" + m.sw));
      b.appendChild(el("span", null, m.nombre));
      b.addEventListener("click", function () {
        sel.material = m.id; sel.problema = null; sel.gravedad = null;
        press(p1.chips, b); press(p2.chips, null); press(p3.chips, null);
        p2.caja.removeAttribute("data-locked");
        p3.caja.setAttribute("data-locked", "true");
        render();
      });
      p1.chips.appendChild(b);
    });

    PROBLEMAS.forEach(function (p) {
      var b = el("button", "gm-chip", p.n);
      b.type = "button";
      b.setAttribute("aria-pressed", "false");
      b.addEventListener("click", function () {
        sel.problema = p.id; sel.gravedad = null;
        press(p2.chips, b); press(p3.chips, null);
        p3.caja.removeAttribute("data-locked");
        render();
      });
      p2.chips.appendChild(b);
    });

    GRAVEDAD.forEach(function (g) {
      var b = el("button", "gm-chip", g.n + ' <em class="gm-chip-nota">' + g.d + "</em>");
      b.type = "button";
      b.setAttribute("aria-pressed", "false");
      b.addEventListener("click", function () {
        sel.gravedad = g.id; press(p3.chips, b); render();
      });
      p3.chips.appendChild(b);
    });

    function render() {
      if (!(sel.material && sel.problema && sel.gravedad)) {
        out.hidden = true;
        vacio.hidden = false;
        vacio.textContent = !sel.material ? "Elige un material para empezar."
          : !sel.problema ? "Ahora dinos qué le pasa."
          : "Falta el último paso: qué tan grave está.";
        return;
      }
      vacio.hidden = true;
      out.hidden = false;

      var d = DIAG[sel.material][sel.problema];
      /* El nivel de DIAG describe el caso "instalada": reciente baja un
         escalón y antigua lo sube uno. */
      var bump  = sel.gravedad === "leve" ? 0 : sel.gravedad === "media" ? 1 : 2;
      var nivel = Math.min(2, Math.max(0, d.nivel + bump - 1));
      var v     = VERDICTOS[nivel];
      var mat   = MATERIALES.filter(function (m) { return m.id === sel.material; })[0];

      clear(out);

      var vb = el("div", "gm-verdict gm-" + v.k);
      vb.appendChild(el("span", "gm-dot"));
      var vt = el("div");
      vt.appendChild(el("h4", null, v.t));
      vt.appendChild(el("p", null, v.d + " " + d.res));
      vb.appendChild(vt);
      out.appendChild(vb);

      out.appendChild(bloque("Protocolo · " + mat.nombre));
      out.appendChild(listaPasos(d.pasos));
      out.appendChild(bloque("Lo que necesitas"));
      out.appendChild(listaProds(d.prods));
      out.appendChild(redSeguridad());
    }
  }

  /* ---------------- 3 · Fichas de material ---------------- */

  function montaMateriales(host) {
    var cards = el("div", "gm-cards");
    var ficha = el("div", "gm-ficha");
    ficha.hidden = true;

    MATERIALES.forEach(function (m) {
      var c = el("button", "gm-card");
      c.type = "button";
      c.setAttribute("aria-pressed", "false");
      c.appendChild(el("div", "gm-swatch gm-" + m.sw));
      var head = el("div");
      head.appendChild(el("div", "gm-code", m.cod));
      head.appendChild(el("h3", null, m.nombre));
      c.appendChild(head);
      c.appendChild(el("p", null, m.resumen));
      c.addEventListener("click", function () {
        var abierta = c.getAttribute("aria-pressed") === "true";
        press(cards, abierta ? null : c);
        if (abierta) { ficha.hidden = true; return; }
        pintaFicha(m);
      });
      cards.appendChild(c);
    });

    function pintaFicha(m) {
      clear(ficha);
      ficha.hidden = false;

      var head = el("div", "gm-ficha-head");
      var izq = el("div");
      izq.appendChild(el("div", "gm-code", m.cod));
      izq.appendChild(el("h3", null, m.nombre));
      head.appendChild(izq);
      head.appendChild(el("div", "gm-swatch gm-" + m.sw));
      ficha.appendChild(head);

      ficha.appendChild(bloque("Cómo reconocerlo"));
      ficha.appendChild(el("p", null, m.reconocer));

      var dl = el("dl", "gm-spec");
      Object.keys(m.spec).forEach(function (k) {
        var row = el("div");
        row.appendChild(el("dt", null, k));
        row.appendChild(el("dd", null, m.spec[k]));
        dl.appendChild(row);
      });
      ficha.appendChild(dl);

      ficha.appendChild(bloque("Sus tres debilidades"));
      var ul = el("ul", "gm-never gm-weak");
      m.debilidades.forEach(function (d) { ul.appendChild(el("li", null, d)); });
      ficha.appendChild(ul);

      ficha.appendChild(bloque("Protocolo paso a paso"));
      ficha.appendChild(listaPasos(m.protocolo));

      ficha.appendChild(bloque("Nunca, y por qué"));
      var nv = el("ul", "gm-never");
      m.nunca.forEach(function (n) { nv.appendChild(el("li", null, n)); });
      ficha.appendChild(nv);

      ficha.appendChild(bloque("Lo que corresponde usar"));
      ficha.appendChild(listaProds(m.productos));

      ficha.appendChild(cajaParar("Cuándo parar", m.parar));
      ficha.appendChild(redSeguridad());
      ficha.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    host.appendChild(cards);
    host.appendChild(ficha);
  }

  /* ---------------- 4 · Manchas ---------------- */

  var LVL = [["gm-lvl-ok", "Rescatable"], ["gm-lvl-warn", "Difícil"], ["gm-lvl-alto", "Crítica"]];

  function montaManchas(host) {
    var grid  = el("div", "gm-grid");
    var ficha = el("div", "gm-ficha");
    ficha.hidden = true;

    MANCHAS.forEach(function (m) {
      var b = el("button", "gm-mancha");
      b.type = "button";
      b.setAttribute("aria-pressed", "false");
      b.appendChild(el("span", "gm-n", m.n));
      b.appendChild(el("span", "gm-lvl " + LVL[m.nivel][0], LVL[m.nivel][1]));
      b.addEventListener("click", function () {
        var abierta = b.getAttribute("aria-pressed") === "true";
        press(grid, abierta ? null : b);
        if (abierta) { ficha.hidden = true; return; }
        pintaFicha(m);
      });
      grid.appendChild(b);
    });

    function pintaFicha(m) {
      clear(ficha);
      ficha.hidden = false;

      var head = el("div", "gm-ficha-head");
      var izq = el("div");
      izq.appendChild(el("div", "gm-code", "MANCHA · " + LVL[m.nivel][1].toUpperCase()));
      izq.appendChild(el("h3", null, m.n));
      head.appendChild(izq);
      ficha.appendChild(head);

      var u = el("div", "gm-urgente");
      u.appendChild(el("div", "gm-eyebrow", "Los primeros 10 minutos"));
      u.appendChild(el("p", null, m.urgente));
      ficha.appendChild(u);

      ficha.appendChild(bloque("Lo que nunca hay que hacer"));
      var nv = el("ul", "gm-never");
      m.noHacer.forEach(function (n) { nv.appendChild(el("li", null, n)); });
      ficha.appendChild(nv);

      ficha.appendChild(bloque("El método cambia según el material"));
      var dl = el("dl", "gm-pormat");
      Object.keys(m.porMat).forEach(function (k) {
        var row = el("div");
        row.appendChild(el("dt", null, k));
        row.appendChild(el("dd", null, m.porMat[k]));
        dl.appendChild(row);
      });
      ficha.appendChild(dl);

      ficha.appendChild(bloque("Lo que necesitas"));
      ficha.appendChild(listaProds(m.prods));

      ficha.appendChild(cajaParar("Cuándo parar", m.rendirse));
      ficha.appendChild(redSeguridad());
      ficha.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    host.appendChild(grid);
    host.appendChild(ficha);
  }

  /* ---------------- 5 · Rescate ---------------- */

  function montaRescate(host) {
    var reglas = el("div", "gm-reglas");
    reglas.appendChild(el("div", "gm-eyebrow", "Las tres reglas del rescate"));
    reglas.appendChild(el("ol", null,
      "<li><b>Para.</b> El 90% de los daños graves vienen de la segunda hora de insistencia, no del error original.</li>" +
      "<li><b>No sumes un producto nuevo encima.</b> Enjuaga, seca, evalúa. Recién ahí decide.</li>" +
      "<li><b>Deja secar antes de juzgar.</b> Más de la mitad de los «lo arruiné» desaparecen solos a las 24 h.</li>"));
    host.appendChild(reglas);

    var grid  = el("div", "gm-grid");
    var ficha = el("div", "gm-ficha");
    ficha.hidden = true;

    RESCATE.forEach(function (r) {
      var b = el("button", "gm-mancha");
      b.type = "button";
      b.setAttribute("aria-pressed", "false");
      b.appendChild(el("span", "gm-n", r.n));
      b.appendChild(el("span", "gm-lvl " + (r.rec === 0 ? "gm-lvl-ok" : r.rec === 1 ? "gm-lvl-warn" : "gm-lvl-alto"),
                       REC[r.rec][1]));
      b.addEventListener("click", function () {
        var abierta = b.getAttribute("aria-pressed") === "true";
        press(grid, abierta ? null : b);
        if (abierta) { ficha.hidden = true; return; }
        pintaFicha(r);
      });
      grid.appendChild(b);
    });

    function pintaFicha(r) {
      clear(ficha);
      ficha.hidden = false;

      var head = el("div", "gm-ficha-head");
      var izq = el("div");
      izq.appendChild(el("div", "gm-code", "RESCATE"));
      izq.appendChild(el("h3", null, r.n));
      head.appendChild(izq);
      head.appendChild(el("span", "gm-rescatable gm-" + REC[r.rec][0], REC[r.rec][1]));
      ficha.appendChild(head);

      ficha.appendChild(bloque("Qué pasó"));
      ficha.appendChild(el("p", null, r["pasó"]));

      var c = el("div", "gm-causa");
      c.appendChild(el("div", "gm-eyebrow", "Por qué pasó"));
      c.appendChild(el("p", null, r.causa));
      ficha.appendChild(c);

      ficha.appendChild(bloque("Rescate"));
      ficha.appendChild(listaPasos(r.pasos));

      ficha.appendChild(bloque("Lo que necesitas"));
      ficha.appendChild(listaProds(r.prods));

      ficha.appendChild(cajaParar("Cómo no repetirlo", r.evitar));
      ficha.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    host.appendChild(grid);
    host.appendChild(ficha);
  }

  /* ---------------- 6 · Tabla de compatibilidad ---------------- */

  var SYM = { si: ["●", "gm-m-si", "Sí"], cui: ["▲", "gm-m-cui", "Con cuidado"], no: ["✕", "gm-m-no", "Nunca"] };
  var COLS = ["Shampoo", "Bubble", "Gel", "Activate", "SneakSole", "Protocol", "Soft", "Medium", "Brass"];

  function montaTabla(host) {
    var wrap = el("div", "gm-tabla-wrap");
    var tabla = el("table", "gm-compat");
    var thead = el("thead");
    var trh = el("tr");
    trh.appendChild(el("th", "gm-col-mat", "Material"));
    COLS.forEach(function (c) { trh.appendChild(el("th", null, c)); });
    thead.appendChild(trh);
    tabla.appendChild(thead);

    var tbody = el("tbody");
    TABLA.forEach(function (row) {
      var tr = el("tr");
      var th = el("th", "gm-col-mat", row[0]);
      th.scope = "row";
      tr.appendChild(th);
      row[1].forEach(function (v) {
        var td = el("td");
        var s = SYM[v];
        var b = el("span", "gm-mark " + s[1], s[0]);
        b.title = s[2];
        td.appendChild(b);
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    tabla.appendChild(tbody);
    wrap.appendChild(tabla);
    host.appendChild(wrap);

    host.appendChild(el("div", "gm-leyenda",
      '<span><b class="gm-mark gm-m-si">●</b> Sí</span>' +
      '<span><b class="gm-mark gm-m-cui">▲</b> Con cuidado</span>' +
      '<span><b class="gm-mark gm-m-no">✕</b> Nunca</span>'));
  }

  /* ---------------- Registro ---------------- */

  var HERRAMIENTAS = [
    { id: "t-diagnostico", n: "◆", t: "Diagnóstico",    monta: montaDiagnostico,
      d: "Dinos qué material es, qué le pasa y qué tan grave está. Te devolvemos el protocolo exacto." },
    { id: "t-anatomia",    n: "◆", t: "Anatomía",       monta: montaAnatomia,
      d: "Toca una parte del dibujo y te decimos cómo se llama en español, cómo la vas a ver escrita en inglés, y a qué capítulo ir." },
    { id: "t-manchas",     n: "◆", t: "Buscar mancha",  monta: montaManchas,
      d: "Veinticuatro manchas. Qué hacer en los primeros diez minutos, qué no hacer nunca, y el método distinto según el material." },
    { id: "t-rescate",     n: "◆", t: "Rescate rápido", monta: montaRescate,
      d: "Los desastres más comunes, con su rescate paso a paso." },
    { id: "t-materiales",  n: "◆", t: "Fichas por material", monta: montaMateriales,
      d: "Ocho fichas: cómo reconocerlo, sus debilidades, el protocolo con tiempos, las prohibiciones y cuándo parar." },
    { id: "t-tabla",       n: "◆", t: "Qué usar en qué", monta: montaTabla,
      d: "La tabla que evita el 90% de los desastres: cada producto sobre cada material." }
  ];

  window.GUIA_MECANICAS = {
    lista: HERRAMIENTAS.map(function (h) { return { id: h.id, n: h.n, t: h.t, d: h.d }; }),
    es: function (id) {
      return HERRAMIENTAS.some(function (h) { return h.id === id; });
    },
    /* host = el contenedor donde va la herramienta · irA = navegar a un capítulo */
    monta: function (id, host, irA) {
      apagaRelojes();
      var h = HERRAMIENTAS.filter(function (x) { return x.id === id; })[0];
      if (!h) return false;
      var caja = el("div", "gm-tool");
      host.appendChild(caja);
      h.monta(caja, irA || function () {});
      return true;
    },
    apagaRelojes: apagaRelojes
  };

})();
